var _path, _polygon, _polygon2, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 396.65,
    y: 224.53,
    width: 62.19,
    height: 188.79,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 427.74,
    y: 224.53,
    width: 31.09,
    height: 188.6,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.75,
    y: 205.18,
    width: 21.96,
    height: 19.35,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.48,
    y: 205.18,
    width: 5.23,
    height: 19.35,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "391.47 224.53 391.47 223.4 460.66 223.4 460.66 224.53",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.92,
    y: 232.96,
    width: 5.26,
    height: 11.1,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.74,248.42c0,.12-7,.21-15.54.21s-15.55-.09-15.55-.21,7-.21,15.55-.21S427.74,248.3,427.74,248.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.29,
    y: 232.96,
    width: 5.26,
    height: 11.1,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.11,248.42c0,.12-7,.21-15.55.21s-15.55-.09-15.55-.21,7-.21,15.55-.21S459.11,248.3,459.11,248.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.29,
    y: 255,
    width: 5.26,
    height: 11.1,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.11,270.46c0,.11-7,.21-15.55.21s-15.55-.1-15.55-.21,7-.21,15.55-.21S459.11,270.34,459.11,270.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.29,
    y: 277.7,
    width: 5.26,
    height: 11.1,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.11,293.16c0,.12-7,.21-15.55.21s-15.55-.09-15.55-.21,7-.21,15.55-.21S459.11,293,459.11,293.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.29,
    y: 300.41,
    width: 5.26,
    height: 11.1,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.11,315.86c0,.12-7,.21-15.55.21S428,316,428,315.86s7-.21,15.55-.21S459.11,315.74,459.11,315.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.29,
    y: 322.46,
    width: 5.26,
    height: 11.1,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.11,337.91c0,.12-7,.22-15.55.22S428,338,428,337.91s7-.21,15.55-.21S459.11,337.8,459.11,337.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.29,
    y: 344.6,
    width: 5.26,
    height: 11.1,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.29,
    y: 367.03,
    width: 5.26,
    height: 11.1,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.11,360.06c0,.11-7,.21-15.55.21s-15.55-.1-15.55-.21,7-.22,15.55-.22S459.11,359.94,459.11,360.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.92,
    y: 255.34,
    width: 5.26,
    height: 11.1,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.74,270.79c0,.12-7,.22-15.54.22s-15.55-.1-15.55-.22,7-.21,15.55-.21S427.74,270.68,427.74,270.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.92,
    y: 277.71,
    width: 5.26,
    height: 11.1,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.74,293.17c0,.11-7,.21-15.54.21s-15.55-.1-15.55-.21,7-.22,15.55-.22S427.74,293.05,427.74,293.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.92,
    y: 300.08,
    width: 5.26,
    height: 11.1,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.74,315.54c0,.12-7,.21-15.54.21s-15.55-.09-15.55-.21,7-.21,15.55-.21S427.74,315.42,427.74,315.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.92,
    y: 322.46,
    width: 5.26,
    height: 11.1,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.74,337.91c0,.12-7,.22-15.54.22s-15.55-.1-15.55-.22,7-.21,15.55-.21S427.74,337.8,427.74,337.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.92,
    y: 344.83,
    width: 5.26,
    height: 11.1,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.74,360.29c0,.11-7,.21-15.54.21s-15.55-.1-15.55-.21,7-.21,15.55-.21S427.74,360.17,427.74,360.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.92,
    y: 367.2,
    width: 5.26,
    height: 11.1,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.17,
    y: 257.86,
    width: 0.77,
    height: 40.9,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.16,
    y: 258.49,
    width: 0.77,
    height: 40.9,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.15,
    y: 257.75,
    width: 0.77,
    height: 40.9,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.14,
    y: 258.49,
    width: 0.77,
    height: 40.9,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.67,
    y: 290.27,
    width: 93.29,
    height: 123.04,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.21,
    y: 290.27,
    width: 43.74,
    height: 123.04,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.23,
    y: 306.93,
    width: 8.39,
    height: 20.38,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.23,
    y: 386.68,
    width: 8.39,
    height: 20.38,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.21,335.3c0,.23-11.09.42-24.77.42s-24.77-.19-24.77-.42,11.09-.41,24.77-.41S328.21,335.07,328.21,335.3Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.23,
    y: 347.11,
    width: 8.39,
    height: 20.38,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.21,375.48c0,.23-11.09.42-24.77.42s-24.77-.19-24.77-.42,11.09-.41,24.77-.41S328.21,375.26,328.21,375.48Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.5,
    y: 306.93,
    width: 8.39,
    height: 20.38,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.7,
    y: 306.93,
    width: 8.39,
    height: 20.38,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.5,
    y: 345.59,
    width: 8.39,
    height: 20.38,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.7,
    y: 345.59,
    width: 8.39,
    height: 20.38,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.5,
    y: 384.26,
    width: 8.39,
    height: 20.38,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.7,
    y: 384.26,
    width: 8.39,
    height: 20.38,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.21 292.37 328.21 281.28 337.5 281.28 337.5 275.19 350.09 275.19 350.09 269.76 371.96 269.76 371.96 291.5 328.21 292.37",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.8,
    y: 251.7,
    width: 0.77,
    height: 40.9,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.12,
    y: 251.7,
    width: 0.77,
    height: 40.9,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.7,
    y: 245.94,
    width: 0.77,
    height: 40.9,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.93,
    y: 245.94,
    width: 0.77,
    height: 40.9,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.31,
    y: 245.94,
    width: 0.77,
    height: 40.9,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.88,
    y: 279.35,
    width: 48.34,
    height: 0.77,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.98,
    y: 269.37,
    width: 70.21,
    height: 0.77,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.27,
    y: 237.58,
    width: 57.88,
    height: 175.71,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.21,
    y: 237.58,
    width: 28.94,
    height: 175.71,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.87,
    y: 219.57,
    width: 20.44,
    height: 18.01,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.44,
    y: 219.57,
    width: 4.87,
    height: 18.01,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "24.44 237.58 24.44 236.53 88.84 236.53 88.84 237.58",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.69,
    y: 245.43,
    width: 4.9,
    height: 10.33,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.21,259.82c0,.11-6.48.19-14.47.19s-14.47-.08-14.47-.19,6.47-.2,14.47-.2S58.21,259.71,58.21,259.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.88,
    y: 245.43,
    width: 4.9,
    height: 10.33,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4,259.82c0,.11-6.48.19-14.47.19s-14.47-.08-14.47-.19,6.48-.2,14.47-.2S87.4,259.71,87.4,259.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.88,
    y: 265.94,
    width: 4.9,
    height: 10.33,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4,280.33c0,.11-6.48.2-14.47.2s-14.47-.09-14.47-.2,6.48-.2,14.47-.2S87.4,280.22,87.4,280.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.88,
    y: 287.07,
    width: 4.9,
    height: 10.33,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4,301.46c0,.11-6.48.2-14.47.2s-14.47-.09-14.47-.2,6.48-.2,14.47-.2S87.4,301.35,87.4,301.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.88,
    y: 308.2,
    width: 4.9,
    height: 10.33,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4,322.59c0,.11-6.48.19-14.47.19s-14.47-.08-14.47-.19,6.48-.2,14.47-.2S87.4,322.48,87.4,322.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.88,
    y: 328.73,
    width: 4.9,
    height: 10.33,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4,343.11c0,.11-6.48.2-14.47.2s-14.47-.09-14.47-.2,6.48-.19,14.47-.19S87.4,343,87.4,343.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.88,
    y: 349.34,
    width: 4.9,
    height: 10.33,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.88,
    y: 370.21,
    width: 4.9,
    height: 10.33,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4,363.72c0,.11-6.48.2-14.47.2s-14.47-.09-14.47-.2,6.48-.2,14.47-.2S87.4,363.61,87.4,363.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.69,
    y: 266.26,
    width: 4.9,
    height: 10.33,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.21,280.64c0,.11-6.48.2-14.47.2s-14.47-.09-14.47-.2,6.47-.2,14.47-.2S58.21,280.53,58.21,280.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.69,
    y: 287.08,
    width: 4.9,
    height: 10.33,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.21,301.47c0,.1-6.48.19-14.47.19s-14.47-.09-14.47-.19,6.47-.2,14.47-.2S58.21,301.36,58.21,301.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.69,
    y: 307.9,
    width: 4.9,
    height: 10.33,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.21,322.29c0,.11-6.48.2-14.47.2s-14.47-.09-14.47-.2,6.47-.2,14.47-.2S58.21,322.18,58.21,322.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.69,
    y: 328.73,
    width: 4.9,
    height: 10.33,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.21,343.11c0,.11-6.48.2-14.47.2s-14.47-.09-14.47-.2,6.47-.19,14.47-.19S58.21,343,58.21,343.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.69,
    y: 349.55,
    width: 4.9,
    height: 10.33,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.21,363.94c0,.11-6.48.19-14.47.19s-14.47-.08-14.47-.19,6.47-.2,14.47-.2S58.21,363.83,58.21,363.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.69,
    y: 370.38,
    width: 4.9,
    height: 10.33,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.16,
    y: 291.03,
    width: 0.6,
    height: 32.09,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.95,
    y: 291.52,
    width: 0.6,
    height: 32.09,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.75,
    y: 290.94,
    width: 0.6,
    height: 32.09,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.54,
    y: 291.52,
    width: 0.6,
    height: 32.09,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.17,
    y: 316.45,
    width: 73.19,
    height: 96.54,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.04,
    y: 316.45,
    width: 34.32,
    height: 96.54,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.51,
    y: 329.52,
    width: 6.58,
    height: 15.99,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.51,
    y: 392.1,
    width: 6.58,
    height: 15.99,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,351.79c0,.18-8.7.32-19.43.32s-19.44-.14-19.44-.32,8.7-.33,19.44-.33S192,351.61,192,351.79Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.51,
    y: 361.05,
    width: 6.58,
    height: 15.99,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,383.31c0,.18-8.7.33-19.43.33s-19.44-.15-19.44-.33,8.7-.32,19.44-.32S192,383.14,192,383.31Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.33,
    y: 329.52,
    width: 6.58,
    height: 15.99,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.61,
    y: 329.52,
    width: 6.58,
    height: 15.99,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.33,
    y: 359.86,
    width: 6.58,
    height: 15.99,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.61,
    y: 359.86,
    width: 6.58,
    height: 15.99,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.33,
    y: 390.2,
    width: 6.58,
    height: 15.99,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.61,
    y: 390.2,
    width: 6.58,
    height: 15.99,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.04 318.11 192.04 309.41 199.33 309.41 199.33 304.63 209.2 304.63 209.2 300.36 226.36 300.36 226.36 317.42 192.04 318.11",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.72,
    y: 286.2,
    width: 0.6,
    height: 32.09,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.03,
    y: 286.2,
    width: 0.6,
    height: 32.09,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.9,
    y: 281.68,
    width: 0.6,
    height: 32.09,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.55,
    y: 281.68,
    width: 0.6,
    height: 32.09,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.23,
    y: 281.68,
    width: 0.6,
    height: 32.09,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.12,
    y: 307.89,
    width: 37.93,
    height: 0.6,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.19,
    y: 300.06,
    width: 55.09,
    height: 0.6,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.73,413.31c0-.14,105-.26,234.46-.26s234.48.12,234.48.26-105,.26-234.48.26S12.73,413.45,12.73,413.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.91,313.9H184.2V105.81h4.71Zm-4.41-.3h4.11V106.11H184.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 176.36,
    width: 4.41,
    height: 1.2,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 178.29,
    width: 4.41,
    height: 1.2,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 180.67,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 182.6,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 184.53,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 186.46,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 188.39,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 189.87,
    width: 4.41,
    height: 1.2,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 192.25,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 193.73,
    width: 4.41,
    height: 1.2,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 196.11,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 198.04,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 199.97,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 201.9,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 203.83,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 205.76,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 207.24,
    width: 4.41,
    height: 1.2,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 209.62,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 211.55,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 213.04,
    width: 4.41,
    height: 1.2,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 215.41,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 217.34,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 219.27,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 221.21,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 223.14,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 224.62,
    width: 4.41,
    height: 1.2,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 226.55,
    width: 4.41,
    height: 1.2,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 228.93,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 230.86,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 232.79,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 234.72,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 236.65,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 238.58,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 240.06,
    width: 4.41,
    height: 1.2,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 242.44,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 243.92,
    width: 4.41,
    height: 1.2,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 246.3,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 247.78,
    width: 4.41,
    height: 1.2,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 250.16,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 252.09,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 254.02,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 255.95,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 257.88,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 259.36,
    width: 4.41,
    height: 1.2,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 261.74,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 263.22,
    width: 4.41,
    height: 1.2,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 265.6,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 267.53,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 269.46,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 271.39,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 273.32,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 275.25,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 277.18,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 279.11,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 280.59,
    width: 4.41,
    height: 1.2,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 282.97,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 284.9,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 286.83,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 288.76,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 290.69,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 292.62,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 294.55,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 296.48,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 297.96,
    width: 4.41,
    height: 1.2,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 300.34,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 302.27,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 304.2,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 306.13,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 308.06,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 309.99,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 174.56,
    width: 4.41,
    height: 1.2,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 173.21,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 171.42,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 169.62,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 167.82,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 166.02,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 164.22,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 162.42,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 160.17,
    width: 4.41,
    height: 1.2,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 158.82,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 156.57,
    width: 4.41,
    height: 1.2,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 155.22,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 153.42,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 151.63,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 149.83,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 148.03,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 146.23,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 144.43,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 142.63,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 140.83,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 138.58,
    width: 4.41,
    height: 1.2,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 137.23,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 135.43,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 133.63,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 131.84,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 130.04,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 128.24,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 126.44,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 124.64,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 122.39,
    width: 4.41,
    height: 1.2,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 121.04,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 119.24,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 117.44,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 115.64,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 113.84,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 112.04,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 110.25,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.35,
    y: 108.45,
    width: 4.41,
    height: 0.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.32,314.2a.45.45,0,0,1-.45-.45c0-30.76.06-68.33.12-104.66s.13-73.89.13-104.65a.45.45,0,0,1,.45-.45.45.45,0,0,1,.45.45c0,30.76-.07,68.32-.13,104.65s-.12,73.9-.12,104.66A.45.45,0,0,1,197.32,314.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.32,155.42a.44.44,0,0,1-.36-.18L173.83,124a.45.45,0,1,1,.72-.54l23.13,31.26a.45.45,0,0,1-.09.63A.46.46,0,0,1,197.32,155.42Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.32,138.78a.47.47,0,0,1-.36-.18l-23.13-31.27a.45.45,0,0,1,.09-.63.46.46,0,0,1,.63.1l23.13,31.26a.45.45,0,0,1-.09.63A.46.46,0,0,1,197.32,138.78Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.32,173.06a.44.44,0,0,1-.36-.18l-23.13-31.26a.45.45,0,0,1,.72-.54l23.13,31.27a.44.44,0,0,1-.09.62A.46.46,0,0,1,197.32,173.06Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.32,190.71a.45.45,0,0,1-.36-.19l-23.13-31.26a.45.45,0,0,1,.09-.63.46.46,0,0,1,.63.1L197.68,190a.45.45,0,0,1-.09.63A.46.46,0,0,1,197.32,190.71Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.32,208.35a.47.47,0,0,1-.36-.18L173.83,176.9a.45.45,0,0,1,.09-.63.46.46,0,0,1,.63.1l23.13,31.26a.45.45,0,0,1-.09.63A.46.46,0,0,1,197.32,208.35Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.32,226a.44.44,0,0,1-.36-.18l-23.13-31.26a.45.45,0,0,1,.72-.54l23.13,31.26a.45.45,0,0,1-.09.63A.46.46,0,0,1,197.32,226Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.32,243.63a.44.44,0,0,1-.36-.18l-23.13-31.26a.45.45,0,0,1,.72-.54l23.13,31.27a.44.44,0,0,1-.09.62A.46.46,0,0,1,197.32,243.63Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.32,261.27a.44.44,0,0,1-.36-.18l-23.13-31.26a.45.45,0,0,1,.09-.63.46.46,0,0,1,.63.1l23.13,31.26a.44.44,0,0,1-.36.71Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.32,278.92a.47.47,0,0,1-.36-.18l-23.13-31.27a.45.45,0,0,1,.09-.63.46.46,0,0,1,.63.1l23.13,31.26a.45.45,0,0,1-.09.63A.46.46,0,0,1,197.32,278.92Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.08,295.45a.44.44,0,0,1-.36-.18l-22.89-30.15a.45.45,0,1,1,.72-.54l22.88,30.15a.45.45,0,0,1-.08.63A.46.46,0,0,1,197.08,295.45Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.32,314.2H174a.45.45,0,0,1-.45-.45V105.16a.45.45,0,0,1,.45-.45.45.45,0,0,1,.45.45v177a.41.41,0,0,1,.12.11l23.13,31.26a.45.45,0,0,1,0,.47A.44.44,0,0,1,197.32,314.2Zm-22.89-.9h22l-22-29.74Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,153a.44.44,0,0,1-.27-.09.45.45,0,0,1-.09-.63l23.46-31.35a.45.45,0,0,1,.72.54l-23.47,31.35A.42.42,0,0,1,174,153Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,136.09a.44.44,0,0,1-.27-.09.45.45,0,0,1-.1-.62l23.13-31.75a.45.45,0,0,1,.73.53l-23.13,31.75A.45.45,0,0,1,174,136.09Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,170.9a.5.5,0,0,1-.27-.08.46.46,0,0,1-.1-.63l23.13-31.74a.44.44,0,0,1,.63-.1.46.46,0,0,1,.1.63l-23.13,31.74A.45.45,0,0,1,174,170.9Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,188.81a.43.43,0,0,1-.27-.08.46.46,0,0,1-.1-.63l23.47-32.21a.45.45,0,0,1,.63-.09.44.44,0,0,1,.09.62l-23.46,32.21A.45.45,0,0,1,174,188.81Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,206.73a.44.44,0,0,1-.27-.09.46.46,0,0,1-.1-.63l23.13-31.74a.45.45,0,0,1,.73.53l-23.13,31.74A.47.47,0,0,1,174,206.73Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,224.64a.44.44,0,0,1-.27-.09.45.45,0,0,1-.1-.62l23.13-31.75a.45.45,0,0,1,.73.53l-23.13,31.74A.44.44,0,0,1,174,224.64Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,242.55a.5.5,0,0,1-.27-.08.46.46,0,0,1-.1-.63l23.13-31.74a.44.44,0,0,1,.63-.1.46.46,0,0,1,.1.63l-23.13,31.74A.45.45,0,0,1,174,242.55Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,260.46a.43.43,0,0,1-.27-.08.46.46,0,0,1-.1-.63L196.74,228a.45.45,0,0,1,.73.53l-23.13,31.74A.45.45,0,0,1,174,260.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,278.38a.44.44,0,0,1-.27-.09.46.46,0,0,1-.1-.63l23.13-31.74a.45.45,0,0,1,.73.53l-23.13,31.74A.47.47,0,0,1,174,278.38Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,296.29a.44.44,0,0,1-.27-.09.45.45,0,0,1-.1-.62l23.13-31.75a.45.45,0,0,1,.73.53L174.34,296.1A.44.44,0,0,1,174,296.29Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,314.2a.5.5,0,0,1-.27-.08.46.46,0,0,1-.1-.63l23.13-31.74a.44.44,0,0,1,.63-.1.46.46,0,0,1,.1.63L174.34,314A.45.45,0,0,1,174,314.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.38,73.22l-.79-.89,11-9.86h.23c23.52,0,47.48,0,71.45.07s47.93.08,71.44.08v1.2c-23.51,0-47.48,0-71.44-.08s-47.77-.07-71.22-.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.45,76.42a.6.6,0,0,1-.4-1l14.18-12.6a.61.61,0,0,1,.81,0L224.12,75l12.63-12.21a.61.61,0,0,1,.82,0L251.45,75l12.76-12.22a.6.6,0,0,1,.81,0L278.79,75l13.1-12.23a.61.61,0,0,1,.81,0l14,12.24,12.53-12.22a.61.61,0,0,1,.83,0L333.36,75l13-12.22a.61.61,0,0,1,.81,0l14.41,12.6a.61.61,0,0,1,.05.85.59.59,0,0,1-.84,0L346.77,64l-13,12.23a.6.6,0,0,1-.82,0L319.65,64.05l-12.52,12.2a.6.6,0,0,1-.82,0L292.32,64,279.21,76.26a.59.59,0,0,1-.8,0L264.64,64,251.88,76.26a.6.6,0,0,1-.81,0L237.19,64,224.54,76.25a.58.58,0,0,1-.82,0L210.62,64,196.84,76.27A.58.58,0,0,1,196.45,76.42Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.37,
    y: 65.11,
    width: 24.15,
    height: 28.43,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.15,93.55c-.17,0-.31-6.37-.31-14.22s.14-14.22.31-14.22.32,6.37.32,14.22S118.33,93.55,118.15,93.55Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.45,93.55c-.17,0-.31-6.37-.31-14.22s.14-14.22.31-14.22.31,6.37.31,14.22S127.62,93.55,127.45,93.55Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.46,76.63H108.09V72.48H361.46ZM108.69,76H360.86v-3H108.69Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,76.63a.33.33,0,0,1-.16,0l-13.41-9a.3.3,0,0,1-.08-.41.3.3,0,0,1,.42-.08l13.4,9a.3.3,0,0,1-.17.55Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,76.57a.3.3,0,0,1-.29-.26l-1.15-8.92-13.22,9.13a.3.3,0,0,1-.46-.29l4.91-38.45v0l.61-4.81v0l.71-5.6v0l.6-4.64a.3.3,0,0,1,.3-.27h1.11a.31.31,0,0,1,.3.27l2.53,19.75a0,0,0,0,1,0,0l.63,4.94v0l.67,5.17s0,0,0,.06a.33.33,0,0,1,0,.14l3,23.45a.3.3,0,0,1-.26.34ZM180.65,59.09l-2.11,16.55,12.08-8.34-10.68.22h0a.28.28,0,0,1-.28-.19.29.29,0,0,1,.09-.34l10-7.9Zm9.85.2-9.67,7.62,10.62-.23Zm-9.07-.8h9l-.67-5.26Zm0-5.47-.67,5.18L189,53Zm.76-.6h7.43L189.05,48Zm-.09-4.68-.56,4.39,6.74-4.39Zm.67-.6h6.17L188.41,43Zm0-4.37-.51,4,5.51-4Zm.59-.6h5l-.48-3.74Zm0-4.06-.47,3.66,4.37-3.63Zm.41-.6,4,0-.49-3.86Zm.21-4.23-.47,3.62,3.28-3.6Zm.23-.59,2.91,0-.57-4.44Zm.48-5-.47,3.74,2-3.78Zm.6-4.65-.52,4.05,1.62,0-.51-4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.46,33.34a.3.3,0,0,1-.27-.16l-3-5.68a.3.3,0,0,1,.13-.4.29.29,0,0,1,.4.12l3,5.68a.31.31,0,0,1-.12.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.07,38.17a.28.28,0,0,1-.22-.1l-4.37-4.8a.3.3,0,0,1,.45-.4l4.36,4.8a.28.28,0,0,1,0,.42A.28.28,0,0,1,188.07,38.17Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.65,42.83a.26.26,0,0,1-.19-.07l-5.57-4.62a.31.31,0,0,1,0-.42.31.31,0,0,1,.43,0l5.56,4.62a.29.29,0,0,1,0,.42A.28.28,0,0,1,188.65,42.83Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.28,47.8a.27.27,0,0,1-.17-.06l-6.79-5a.28.28,0,0,1-.07-.41.3.3,0,0,1,.42-.07l6.79,5a.31.31,0,0,1,.07.42A.3.3,0,0,1,189.28,47.8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,53.08a.33.33,0,0,1-.16,0l-8.1-5.28a.31.31,0,0,1-.09-.42.31.31,0,0,1,.42-.08l8.1,5.28a.3.3,0,0,1-.17.55Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.74,59.15a.24.24,0,0,1-.16,0L181,53a.3.3,0,0,1,.32-.5l9.58,6.07A.29.29,0,0,1,191,59,.3.3,0,0,1,190.74,59.15Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.62,67.27a.27.27,0,0,1-.18,0L180.3,59.09a.3.3,0,1,1,.36-.48l11.13,8.12a.3.3,0,0,1-.17.54Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.57,88.35a.3.3,0,0,1-.3-.3V21.93a.3.3,0,0,1,.3-.3.29.29,0,0,1,.3.3V88.05A.29.29,0,0,1,185.57,88.35Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.14,
    y: 76.33,
    width: 6.81,
    height: 23.16,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.48,
    y: 87.61,
    width: 18.38,
    height: 12.17,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.76,
    y: 90.17,
    width: 5.77,
    height: 9.61,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.09,
    y: 103.43,
    width: 29.51,
    height: 4.32,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.65,
    y: 99.25,
    width: 23.76,
    height: 2.4,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.9,
    y: 101.36,
    width: 21.28,
    height: 2.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.96,
    y: 163.55,
    width: 23.48,
    height: 2.4,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.96,
    y: 215.56,
    width: 23.36,
    height: 2.4,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.96,
    y: 270.34,
    width: 23.36,
    height: 2.4,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.17 68.13 111.86 67.62 185.62 22.11 185.75 22.15 306.02 62.89 305.82 63.46 185.69 22.77 112.17 68.13",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.26 72.73 176.96 72.73 176.96 68.03 108.54 68.03 108.54 72.73 108.24 72.73 108.24 67.72 177.26 67.72 177.26 72.73",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.87,
    y: 67.87,
    width: 0.3,
    height: 4.73,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.97,
    y: 67.87,
    width: 0.3,
    height: 4.73,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.07,
    y: 67.87,
    width: 0.3,
    height: 4.73,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.18,
    y: 67.87,
    width: 0.3,
    height: 4.73,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.28,
    y: 67.87,
    width: 0.3,
    height: 4.73,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.38,
    y: 67.87,
    width: 0.3,
    height: 4.73,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.49,
    y: 67.87,
    width: 0.3,
    height: 4.73,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.59,
    y: 67.87,
    width: 0.3,
    height: 4.73,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.69,
    y: 67.87,
    width: 0.3,
    height: 4.73,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.79,
    y: 67.87,
    width: 0.3,
    height: 4.73,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.9,
    y: 67.87,
    width: 0.3,
    height: 4.73,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 67.87,
    width: 0.3,
    height: 4.73,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.1,
    y: 67.87,
    width: 0.3,
    height: 4.73,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.21,
    y: 67.87,
    width: 0.3,
    height: 4.73,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.31,
    y: 67.87,
    width: 0.3,
    height: 4.73,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.41,
    y: 67.87,
    width: 0.3,
    height: 4.73,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.51,
    y: 67.87,
    width: 0.3,
    height: 4.73,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.62,
    y: 67.87,
    width: 0.3,
    height: 4.73,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.72,
    y: 67.87,
    width: 0.3,
    height: 4.73,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.82,
    y: 67.87,
    width: 0.3,
    height: 4.73,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.93,
    y: 67.87,
    width: 0.3,
    height: 4.73,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.24,
    y: 72.78,
    width: 6.28,
    height: 3.56,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.62,
    y: 72.78,
    width: 6.28,
    height: 3.56,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.01,
    y: 72.78,
    width: 6.28,
    height: 3.56,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.03,
    y: 72.78,
    width: 6.28,
    height: 3.56,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.05,
    y: 72.78,
    width: 6.28,
    height: 3.56,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.08,
    y: 72.78,
    width: 6.28,
    height: 3.56,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.1,
    y: 72.78,
    width: 6.28,
    height: 3.56,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.12,
    y: 72.78,
    width: 6.28,
    height: 3.56,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.15,
    y: 72.78,
    width: 6.28,
    height: 3.56,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.17,
    y: 72.78,
    width: 6.28,
    height: 3.56,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.19,
    y: 72.78,
    width: 6.28,
    height: 3.56,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.49,
    y: 72.78,
    width: 6.28,
    height: 3.56,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.74,
    y: 72.78,
    width: 6.28,
    height: 3.56,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.99,
    y: 72.78,
    width: 6.28,
    height: 3.56,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.13,
    y: 44.97,
    width: 77.19,
    height: 0.6,
    transform: "translate(2.63 98.65) rotate(-35.87)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.22,77.57a2.62,2.62,0,1,1-2.62-2.63A2.62,2.62,0,0,1,364.22,77.57Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.47,77.57a2.62,2.62,0,1,1-2.62-2.63A2.62,2.62,0,0,1,353.47,77.57Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.76,
    y: 72.07,
    width: 14.84,
    height: 4.74,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.55,
    y: 21.38,
    width: 2.21,
    height: 2.21,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.36,24.19H184V20.78h3.41ZM185.15,23h1V22h-1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.25,76.27a3.41,3.41,0,0,1,2.81,3.58v7.76h-15.3L183,76.34Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.25,76.27a3.48,3.48,0,0,1-.88.09l-2.5.08L183,76.6l.27-.26c-.05,3.31-.1,7.15-.15,11.27l-.31-.31H185l13.07,0-.26.27c0-1.9,0-3.65,0-5.22,0-.77,0-1.49,0-2.17a4.92,4.92,0,0,0-.19-1.77,3.24,3.24,0,0,0-1.6-1.82c-.52-.27-.84-.33-.83-.36a1.92,1.92,0,0,1,.9.21A3.3,3.3,0,0,1,198,78.35a4.84,4.84,0,0,1,.28,1.87c0,.68,0,1.4,0,2.17,0,1.57,0,3.32.05,5.22v.26h-.28l-13.07,0h-2.55V87.6c.09-4.12.17-8,.24-11.27v-.26H183l8.94.06,2.49.06A3.73,3.73,0,0,1,195.25,76.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.07,79.31c.11.14-1.15,1.36-2.82,2.74s-3.11,2.38-3.22,2.25,1.15-1.36,2.82-2.73S193,79.18,193.07,79.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.52,81.59c.11.13-.77,1.07-2,2.08s-2.27,1.74-2.38,1.61.77-1.06,2-2.08S193.41,81.46,193.52,81.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.34,99.78c-.18,0-.31-5.18-.31-11.57s.13-11.57.31-11.57.31,5.18.31,11.57S176.51,99.78,176.34,99.78Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.57,99.78c0,.17-5.45.31-12.17.31s-12.17-.14-12.17-.31,5.45-.31,12.17-.31S197.57,99.61,197.57,99.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.57,101.64c0,.18-5.36.32-12,.32s-12-.14-12-.32,5.35-.31,12-.31S197.57,101.47,197.57,101.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.15,103.43c0,.18-5.36.32-12,.32s-12-.14-12-.32,5.35-.31,12-.31S198.15,103.26,198.15,103.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.78,
    y: 61.6,
    width: 8.48,
    height: 1.62,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.06,130.46c.41-3-3.79-5.43-7-5.68-1.5-.12-3.07.11-4.5-.39-3.09-1.08-4.32-5.07-7.34-6.34-2.25-1-4.85-.11-7,1s-4.35,2.49-6.79,2.64c-2.12.14-4.43-.65-6.29.39-1.38.77-2.11,2.37-3.38,3.31a8.06,8.06,0,0,1-4.43,1.2,12.27,12.27,0,0,0-4.56.75A3.59,3.59,0,0,0,32.5,131Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.91,38.85c.41-3-3.79-5.42-7-5.68-1.51-.12-3.07.11-4.5-.39-3.09-1.07-4.32-5.06-7.34-6.34-2.25-1-4.85-.1-7,1s-4.35,2.48-6.79,2.64c-2.12.14-4.43-.65-6.29.39-1.38.77-2.11,2.36-3.39,3.31A8.09,8.09,0,0,1,317.2,35a12.53,12.53,0,0,0-4.57.74,3.61,3.61,0,0,0-2.28,3.66Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.49,134.74c.32-2.34-3-4.27-5.46-4.47a13.82,13.82,0,0,1-3.53-.3c-2.43-.85-3.4-4-5.77-5-1.78-.75-3.82-.08-5.54.78s-3.41,2-5.33,2.08c-1.67.11-3.48-.51-4.94.3-1.09.61-1.66,1.87-2.67,2.61a6.4,6.4,0,0,1-3.48.94,9.83,9.83,0,0,0-3.58.59,2.83,2.83,0,0,0-1.8,2.87Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.35,77.31c.32-2.34-3-4.27-5.47-4.47a13.82,13.82,0,0,1-3.53-.3c-2.43-.85-3.4-4-5.77-5-1.77-.75-3.81-.08-5.53.78s-3.42,2-5.34,2.08c-1.67.11-3.48-.51-4.94.3-1.09.61-1.66,1.87-2.66,2.61a6.4,6.4,0,0,1-3.48.94,9.85,9.85,0,0,0-3.59.59,2.83,2.83,0,0,0-1.8,2.87Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.13,51.94c.32-2.34-3-4.26-5.46-4.46a14.37,14.37,0,0,1-3.54-.31c-2.43-.84-3.4-4-5.77-5-1.77-.75-3.81-.08-5.53.78s-3.41,2-5.33,2.08c-1.67.1-3.49-.52-5,.3-1.08.61-1.65,1.86-2.66,2.6a6.24,6.24,0,0,1-3.48.94,9.85,9.85,0,0,0-3.59.59A2.84,2.84,0,0,0,65,52.36Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M475.89,460.43c0,.14-101.14.26-225.88.26s-225.9-.12-225.9-.26,101.12-.26,225.9-.26S475.89,460.29,475.89,460.43Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.58,134.36,206.13,136a28.74,28.74,0,1,1,5.32-8.79h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.58,134.36l-.29-.47-.82-1.37c-.71-1.21-1.76-3-3.1-5.23h.17a.1.1,0,0,1-.15,0,.11.11,0,0,1,0-.12,28.78,28.78,0,0,0,1.6-13.8,28.18,28.18,0,0,0-.92-4.33,31.24,31.24,0,0,0-1.74-4.43,28.32,28.32,0,0,0-15.9-14.34,28.63,28.63,0,0,0-12.27-1.62,29.09,29.09,0,0,0-12.45,4.23,27.91,27.91,0,0,0-9.54,9.91A28.47,28.47,0,0,0,206,136l.07,0,7-1.17,1.83-.3.63-.1s-.18,0-.58.12l-1.79.35-7.06,1.33.06,0a28.54,28.54,0,0,1-11.65,8,28.87,28.87,0,0,1-34.88-41.54l.92-1.54c.34-.5.71-1,1.06-1.45a27.31,27.31,0,0,1,2.3-2.72c.39-.44.85-.81,1.28-1.22a14.5,14.5,0,0,1,1.32-1.15,26.52,26.52,0,0,1,2.84-2,29.54,29.54,0,0,1,12.68-4.29A29.15,29.15,0,0,1,204.45,96a28.75,28.75,0,0,1,6.19,8.51,31.3,31.3,0,0,1,1.74,4.5,27.74,27.74,0,0,1,.9,4.38,28.68,28.68,0,0,1-1.73,13.93l-.18-.1v0a.1.1,0,0,1,.14,0s0,0,0,0l3,5.36.76,1.37C215.51,134.21,215.58,134.36,215.58,134.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.33 128.76 170.28 119.36 173.56 114.45 182.98 120.76 194.71 105.24 199.41 108.8 184.33 128.76",
    style: {
      fill: "#2568FC"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425.15,255.33c-.46.15-.9.31-1.35.48A6.25,6.25,0,0,0,422,256.9l-3.47,2.91a6.65,6.65,0,0,0-2.3,3.95,173.53,173.53,0,0,0-2.55,32.41c0,1.33.12,2.81,1.16,3.74a5.57,5.57,0,0,0,3.9.93,13.65,13.65,0,0,0,7.51-2.15c2.74-2,3.8-5.36,4.54-8.51a130.37,130.37,0,0,0,3.07-28.34A6.68,6.68,0,0,0,425.15,255.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.54,432.14l-.81,21.33s21.41,8,21.64,11.94L386,465.33l-.1-33.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.93,451.65a1.69,1.69,0,0,0-1.17,1.93,1.62,1.62,0,0,0,1.9,1.18,1.8,1.8,0,0,0,1.23-2.05,1.68,1.68,0,0,0-2.11-1",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,465.33l.13-3.36,39.65,1.34s1.84.8,1.63,2.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.4,453.26c0,.2-1,.29-2,.94s-1.53,1.5-1.71,1.42.11-1.25,1.33-2S406.45,453.08,406.4,453.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.74,455.07c.05.19-.83.53-1.52,1.39s-.89,1.76-1.09,1.75-.32-1.16.55-2.2S410.74,454.87,410.74,455.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.2,460.27c-.19,0-.46-1,.06-2.07s1.46-1.55,1.55-1.38-.5.76-.92,1.67S413.4,460.25,413.2,460.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.05,448.38c-.09.18-1-.1-2.16,0s-2,.43-2.14.26.76-.89,2.1-1S406.15,448.22,406.05,448.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.86,429.24,353.61,455l4.1,20.85a2.65,2.65,0,0,1-2.27,3.14h0a2.65,2.65,0,0,1-2.27-.83c-3.69-4-17.2-18.89-16.93-20.77.32-2.17.57-27.29.57-27.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.44,479l-19.08-23.34-.07,1.1a4,4,0,0,0,.77,2.63c1.52,2,5.82,7.54,16,18.77a2.63,2.63,0,0,0,2.35.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.18,447.65a1.61,1.61,0,0,1,.3,2.11,1.53,1.53,0,0,1-2.09.32,1.68,1.68,0,0,1-.31-2.24,1.6,1.6,0,0,1,2.21-.09",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M350.28,467.32a8,8,0,0,1,2.38-1.86,8.32,8.32,0,0,1,3-.38c0-.06-.29-.28-.89-.4a4.05,4.05,0,0,0-2.33.26,4.11,4.11,0,0,0-1.84,1.47C350.28,466.92,350.21,467.3,350.28,467.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.89,470.89a19.61,19.61,0,0,1,2.35-1,22.23,22.23,0,0,1,2.54-.17,3,3,0,0,0-2.66-.39C352.57,469.72,351.76,470.81,351.89,470.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.14,462.68a27.48,27.48,0,0,1,3.53-1.73c2.06-.68,3.87-.47,3.88-.65a7.25,7.25,0,0,0-7.41,2.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.17,454.8c.06.16,1.52-.34,3.38-.29s3.29.59,3.36.44a5.07,5.07,0,0,0-3.35-1A5.16,5.16,0,0,0,347.17,454.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.64,447.24a12.4,12.4,0,0,1,3.5-.4,13.21,13.21,0,0,1,3.37,1.07c0-.05-.22-.39-.79-.77a5.75,5.75,0,0,0-5.16-.51C347.93,446.89,347.6,447.18,347.64,447.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.19,445.39a2.33,2.33,0,0,0,.1-1,6.83,6.83,0,0,0-.61-2.6,3,3,0,0,0-1.2-1.52,1.07,1.07,0,0,0-1.21.16,1.74,1.74,0,0,0-.48,1.14,3.73,3.73,0,0,0,3,3.66,4.34,4.34,0,0,0,4.4-2,1.51,1.51,0,0,0,.15-1.24,1,1,0,0,0-1.06-.62,3.63,3.63,0,0,0-1.75.77,7.56,7.56,0,0,0-1.89,1.89,2.22,2.22,0,0,0-.45.86,12.1,12.1,0,0,1,2.56-2.42,3.4,3.4,0,0,1,1.55-.63.55.55,0,0,1,.57.33,1,1,0,0,1-.14.81,3.89,3.89,0,0,1-3.84,1.69,3.26,3.26,0,0,1-2.63-3.08,1.26,1.26,0,0,1,.3-.8.58.58,0,0,1,.67-.1,2.75,2.75,0,0,1,1,1.26A9.93,9.93,0,0,1,351.19,445.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.16,250.18a168.45,168.45,0,0,1,.5,28.76c-.44,5.73-17,164.65-17,164.65H382.6l7.34-149-2.14.47s-14.25,63.54-15.41,73.83c-1.05,9.25-13.07,76.43-13.07,76.43l-23.87.28,7.63-88.87L352,271.46l3.34-24.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M360.7,300.08c.55.25,4.29.18,7.78-4s8.14-27.24,8.14-27.24,20.16,4.43,34.16.89S427,260.88,427,260.88l-51.59.88L369,264.55Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M353.57,259.37l1.63-12.07s69.39.65,70.29,1.61c1.93,2,2,10.46.44,12.26,0,0-10.19,9.63-29.89,7.35C386.69,267.44,353.57,259.37,353.57,259.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.39,254.15c-3.24,0-7,.2-8.93,2.8-1.19,1.6-1.37,3.71-1.5,5.7-.55,8.32-1.1,16.65-.84,25,.1,3.34.44,6.93,2.63,9.45,1.93,2.22,5,3.15,7.87,3.56,3.44.48,7.28.25,9.85-2.09,2.31-2.11,3-5.41,3.62-8.48q3.2-16.63,6.41-33.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,262a3.59,3.59,0,0,1-.94.46,9.37,9.37,0,0,1-1.15.44,15.34,15.34,0,0,1-1.57.45,22.74,22.74,0,0,1-4.19.64,26.66,26.66,0,0,1-5.19-.27,25.81,25.81,0,0,1-5-1.38,22.44,22.44,0,0,1-3.78-1.92,12.84,12.84,0,0,1-1.34-.92,10.64,10.64,0,0,1-1-.77,3.92,3.92,0,0,1-.75-.74c.07-.08,1.18.91,3.24,2.12a24.64,24.64,0,0,0,3.76,1.78A27.85,27.85,0,0,0,358,263.2a29.25,29.25,0,0,0,5.09.3,25.2,25.2,0,0,0,4.13-.52C369.56,262.49,370.93,261.9,371,262Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.78,267.29a16.89,16.89,0,0,1,0-4.19,16.46,16.46,0,0,1,.54-4.15,33.62,33.62,0,0,1-.56,8.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459,191.67s-5.14,15.93-10.75,19.58-13.83,2.11-18-2.08-9.28-9.28-9.28-9.28l-7.1-43.8s7.2,4.81,11.26,9.27,17.21,22.26,17.21,22.26l4.88-2.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.62,182.78c.12.23,0,6,0,6s-6.06,4.66-13.15,1.86-7.14-8.46-7.14-8.46l.91-3.21,1.94-5.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 459.06,
    y: 180.73,
    width: 27.08,
    height: 3.84,
    transform: "translate(945.2 365.31) rotate(180)",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "459.06 180.73 334.9 103.56 360.99 103.56 486.14 180.73 459.06 180.73",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "459.06 180.73 459.06 184.67 414.08 157.16 334.21 106.97 334.21 103.21 459.06 180.73",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "459.06 180.73 459.06 184.67 414.08 157.16 334.21 106.97 334.21 103.21 459.06 180.73"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 456.11,
    y: 175.62,
    width: 27.08,
    height: 3.84,
    transform: "translate(939.3 355.08) rotate(180)",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "456.11 175.62 331.95 98.45 358.04 98.45 483.19 175.62 456.11 175.62",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "456.11 175.62 456.11 179.55 411.13 152.04 331.26 101.85 331.26 98.09 456.11 175.62",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "456.11 175.62 456.11 179.55 411.13 152.04 331.26 101.85 331.26 98.09 456.11 175.62"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M439.73,155.26c-2.92-3,1-4,2.12-4.6s8.89-2.52,9.94,1.41c0,0,3.27,0,3.73,1.79,0,0,12.38,4.53,11.32,11.67L456,159.37S443.05,158.69,439.73,155.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363,146.88s-20.57,10.52-21.36,21.79c-.19,2.75,7.94,39.16,11.93,60.27,1.82,9.61,1.36,14.26,1.36,14.26l.27,4.1c3.64,1.64,33.25,11.09,52.56,9.17,21.68-2.16,18.26-9.8,17.17-14s-2-23.14-2-23.77-8.71-63-8.71-63l-18.95-9.12-2.59-3.81-3.63,7.51L365.2,140.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363,146.88a224.45,224.45,0,0,1,37,32.67l-.54-30.93,15.21,7.32s7.74,52.77,8.28,62.76,3.78,29,3,30.88-8.72,8.95-17.76,9.37c-30.51,1.44-53.6-7.25-53.6-7.25l-1-22.76-4.78-23.79L345,191.5s13.53,23.92,26.7,11.84c10-9.16,5.56-30.89-6.55-41.31-5.65-4.87-16.39-5.67-16.39-5.67S358.89,147.64,363,146.88Z",
    style: {
      fill: "#2568FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.57,228.94s8.2,4.67,29.27,6.94,41-7.46,41-7.46l.88,7.15a91.42,91.42,0,0,1-44,6.48A167.78,167.78,0,0,1,354,237.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.08,240s7.78,4.51,29.17,6.78,42.4-6.17,42.4-6.17l.48,5.11s-18.22,9.56-43.43,7a126.8,126.8,0,0,1-28.32-6.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.78,257.64a5.37,5.37,0,0,1-.11-.81c-.05-.57-.12-1.34-.2-2.3-.17-2.05-.4-4.93-.68-8.47-.56-7.15-1.27-17-2.51-27.91a239.88,239.88,0,0,0-4.55-27.63c-.2-.87-.4-1.7-.59-2.49s-.4-1.51-.58-2.2c-.37-1.38-.68-2.56-1-3.52l-.65-2.21a4,4,0,0,1-.2-.79,5,5,0,0,1,.3.75l.75,2.19c.33.95.67,2.13,1.07,3.5.19.69.4,1.42.62,2.2l.63,2.48a216.65,216.65,0,0,1,4.71,27.66C409,229,409.69,238.87,410.16,246c.21,3.55.39,6.43.51,8.49,0,1,.08,1.73.11,2.31A4.21,4.21,0,0,1,410.78,257.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.1,161.89a9.1,9.1,0,0,1,.33,1.6c.18,1,.41,2.54.67,4.4.53,3.72,1.14,8.88,1.61,14.6s.71,10.91.8,14.67c.05,1.88.07,3.4.06,4.45a10.14,10.14,0,0,1-.06,1.64,8.62,8.62,0,0,1-.14-1.63c-.06-1.14-.13-2.64-.22-4.45-.19-3.75-.49-8.93-1-14.64s-1-10.86-1.45-14.59c-.21-1.8-.38-3.29-.51-4.42A12.17,12.17,0,0,1,417.1,161.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.31,146.61a2.92,2.92,0,0,1,0,.68c0,.5-.05,1.15-.09,1.93-.12,1.69-.24,4.06-.56,7.07l0,.4-.3-.31L389,150.91l.41-.08-3.06,7.92v0l-.1.26-.25-.12c-6.44-3-12.19-5.92-16.31-8.08-2.06-1.09-3.72-2-4.86-2.62l-1.3-.74a3,3,0,0,1-.44-.29,1.75,1.75,0,0,1,.49.19L365,148l4.93,2.47c4.16,2.08,9.93,4.92,16.36,7.94l-.35.14v0c1.08-2.78,2.13-5.46,3.08-7.91l.14-.36.27.28c1.91,2,3.68,3.89,5.22,5.52l-.35.09c.35-2.87.54-5.32.72-7q.12-1.17.21-1.92A2.69,2.69,0,0,1,395.31,146.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M352.06,206.35l-.65-4.45,50,11.4s-7.19,13-22.18,15.37S358.53,216.81,352.06,206.35Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M454.69,162.26a2.57,2.57,0,0,1,2.38,2.44,2.5,2.5,0,0,1-1.74,2.24c-3.3,1.5-10.76,0-10.76,0s-6.26,10.54-8.86,13.05l-9.51,14.22-17.41-12.38,9.15-9.35s5-11.9,8.26-14.24,16.11-3.34,16.28-.84c0,0,10.32-1.16,10.5,4.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.14,190c-.38,1.06-19.67,18.36-19.67,18.36L398.17,190l12.37-7.87C416.47,182.84,420.69,185.81,424.14,190Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.87,161.62a21.17,21.17,0,0,1,5.66-.22,30.13,30.13,0,0,1,5.63.55,31.21,31.21,0,0,1-5.65,0C444.4,161.77,441.88,161.76,441.87,161.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453,161.92a5.47,5.47,0,0,1-.3-1.3v0a3.8,3.8,0,0,0-2.63-2.15,18.28,18.28,0,0,0-5.16-.79c-2.84,0-5.41.13-7.28.25a19.61,19.61,0,0,1-3,.11,15.23,15.23,0,0,1,3-.48,58.23,58.23,0,0,1,7.32-.4,16.92,16.92,0,0,1,5.3.89,3.9,3.9,0,0,1,2.72,2.5v0A4.67,4.67,0,0,1,453,161.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.66,172.67a2.44,2.44,0,0,1,.79-.23,12.86,12.86,0,0,1,2.22-.24,15.49,15.49,0,0,1,7.18,1.59,14.76,14.76,0,0,1,5.58,4.79,11.49,11.49,0,0,1,1.11,1.94,2.09,2.09,0,0,1,.27.78c-.08,0-.55-1-1.68-2.51a16,16,0,0,0-5.51-4.54,16.67,16.67,0,0,0-6.95-1.68C418.82,172.53,417.67,172.76,417.66,172.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.79,181.83a2.64,2.64,0,0,1,.9,0,20.76,20.76,0,0,1,2.45.24,17.36,17.36,0,0,1,7.55,3,18.87,18.87,0,0,1,5.38,6.08,15.65,15.65,0,0,1,1,2.24,2.5,2.5,0,0,1,.23.88c-.08,0-.51-1.18-1.58-2.93a20.41,20.41,0,0,0-5.37-5.85,18.64,18.64,0,0,0-7.3-3C410.06,182,408.78,181.91,408.79,181.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.06,160.08c.77-.44,13.72-2.18,20.32,10.37s12.68,25.93,12.68,25.93l17.54-8,7.65,22.25s-22.41,16.73-33.53,14.22-25.66-31.31-26.4-32.35S334.9,167,347.06,160.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.06,160.08l-.44.32-.56.37c-.21.16-.43.37-.7.6a11.5,11.5,0,0,0-3.26,5.08c-1.77,5.05-1.16,13.08,1.86,22.08.38,1.12.8,2.27,1.3,3.4l1.85,3.33q1.89,3.42,4.07,7a110.75,110.75,0,0,0,10.33,14.56,32.36,32.36,0,0,0,7.12,6.41,10,10,0,0,0,4.59,1.53,17.61,17.61,0,0,0,5-.44,45.48,45.48,0,0,0,9.76-3.56,101.2,101.2,0,0,0,9.41-5.2c2.66-1.66,5.25-3.38,7.72-5.18l-.09.29c-2.66-7.73-5.22-15.19-7.64-22.26l.33.15-17.55,8-.2.09-.1-.2c-3.32-7.27-6.5-13.87-9.41-19.68l-2.14-4.2c-.34-.68-.69-1.34-1-2l-1.09-1.84a19.64,19.64,0,0,0-5.25-5.52,17.67,17.67,0,0,0-5.56-2.64,21,21,0,0,0-4.52-.77,17.21,17.21,0,0,0-2.84.06,6.58,6.58,0,0,0-.72.12l-.24.06a.88.88,0,0,1,.23-.1c.16,0,.4-.1.72-.15a16.87,16.87,0,0,1,2.86-.13,21,21,0,0,1,4.56.71A18,18,0,0,1,361.1,163a20.16,20.16,0,0,1,5.36,5.57l1.11,1.86,1,2,2.16,4.19c2.94,5.8,6.15,12.39,9.49,19.66l-.3-.11c5.49-2.52,11.35-5.22,17.54-8.05l.24-.12.09.26,7.67,22.25.06.18-.15.11q-3.74,2.73-7.76,5.21a101,101,0,0,1-9.46,5.23,45.69,45.69,0,0,1-9.87,3.59,18.17,18.17,0,0,1-5.14.44,10.35,10.35,0,0,1-4.8-1.61,24.87,24.87,0,0,1-3.91-3,43.38,43.38,0,0,1-3.32-3.48,110.78,110.78,0,0,1-10.34-14.66c-1.45-2.4-2.79-4.76-4.05-7l-1.85-3.37c-.51-1.16-.92-2.31-1.3-3.44A54.49,54.49,0,0,1,340.94,176a23.85,23.85,0,0,1,1-9.66,11.49,11.49,0,0,1,3.38-5.09c.27-.22.51-.43.73-.58l.57-.36C346.9,160.16,347.06,160.08,347.06,160.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378,206.33a27.88,27.88,0,0,1,2.09-10,41.11,41.11,0,0,1-1,5A44.73,44.73,0,0,1,378,206.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.71,206.35a5.45,5.45,0,0,1,.41-2.14,12,12,0,0,1,2.77-4.46,12.6,12.6,0,0,1,4.34-2.95,5.4,5.4,0,0,1,2.11-.54c0,.08-.78.3-2,.87a14.77,14.77,0,0,0-4.12,3,13.86,13.86,0,0,0-2.79,4.23C371,205.55,370.8,206.36,370.71,206.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.75,157.36s-.09-.16-.28-.38a1.91,1.91,0,0,0-1.05-.56,11.76,11.76,0,0,0-1.89-.09c-.72,0-1.52,0-2.36.07-3.35.2-6.08.5-6.1.33a6.28,6.28,0,0,1,1.76-.39c1.1-.17,2.62-.37,4.31-.46.85,0,1.66,0,2.4,0a9.6,9.6,0,0,1,2,.21,1.87,1.87,0,0,1,1.13.81C442.8,157.16,442.78,157.36,442.75,157.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.18,99.11a6.09,6.09,0,0,0-3-3c-12.7-5.55-27.38-5.18-40.66-1.26-3.45,1-7.15,2.53-8.8,5.76l0,.22c-.71,2.11.34,4.83,1.95,6.35a13.88,13.88,0,0,0,5.89,2.94c10.11,2.9,20.89,2.23,31.29.66a33.49,33.49,0,0,0,7.2-1.68,13,13,0,0,0,5.93-4.29A5.27,5.27,0,0,0,407.18,99.11Z",
    style: {
      fill: "#2568FC"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M407.18,99.11a6.09,6.09,0,0,0-3-3c-12.7-5.55-27.38-5.18-40.66-1.26-3.45,1-7.15,2.53-8.8,5.76l0,.22c-.71,2.11.34,4.83,1.95,6.35a13.88,13.88,0,0,0,5.89,2.94c10.11,2.9,20.89,2.23,31.29.66a33.49,33.49,0,0,0,7.2-1.68,13,13,0,0,0,5.93-4.29A5.27,5.27,0,0,0,407.18,99.11Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M365.09,121.72a80.89,80.89,0,0,1-4.18-13.37,28.54,28.54,0,0,1,.45-13.87c.22-.68,2.11-5.23,2.82-5.19.5,0-.59,4.24-.32,4.66a24,24,0,0,1,3.37,13.88,63.54,63.54,0,0,1-2.14,13.89",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.43,100.74a21,21,0,0,0-20.78-19.4h-1.08c-11.71.61-17.73,10.9-16.79,22.59l1.8,36.27,23.51,10.11,3.32-6.86s-.1-3-.08-3,11.26-1.68,11.47-12.93C403.9,122.08,403.19,110.87,402.43,100.74Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.33,140.44A27.14,27.14,0,0,1,377.71,136s3.47,8.37,14.7,7.42Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.48,110.53a1.6,1.6,0,0,1-1.56,1.61,1.52,1.52,0,0,1-1.64-1.46,1.6,1.6,0,0,1,1.55-1.61A1.53,1.53,0,0,1,397.48,110.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,105.39c-.2.21-1.41-.7-3.14-.7s-3,.85-3.19.64.12-.48.67-.87a4.34,4.34,0,0,1,2.55-.77,4.21,4.21,0,0,1,2.5.82C399.92,104.92,400.1,105.3,400,105.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382,110.47a1.6,1.6,0,0,1-1.55,1.61,1.53,1.53,0,0,1-1.65-1.46,1.6,1.6,0,0,1,1.56-1.61A1.53,1.53,0,0,1,382,110.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.06,106c-.2.21-1.41-.7-3.14-.7s-3,.85-3.19.64.12-.48.67-.87a4.42,4.42,0,0,1,2.56-.78,4.25,4.25,0,0,1,2.49.83C383,105.52,383.16,105.9,383.06,106Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.19,119.31a11.65,11.65,0,0,1,2.81-.49c.44,0,.86-.13.93-.43a2.22,2.22,0,0,0-.28-1.31l-1.29-3.37c-1.78-4.79-3.07-8.74-2.88-8.81s1.8,3.76,3.58,8.56l1.23,3.39a2.5,2.5,0,0,1,.22,1.73,1.12,1.12,0,0,1-.73.65,3.7,3.7,0,0,1-.75.1A11.05,11.05,0,0,1,389.19,119.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.09,120.48c.28,0,.27,1.86,1.87,3.2s3.6,1.15,3.61,1.41-.44.36-1.29.38a4.69,4.69,0,0,1-3-1.07,4,4,0,0,1-1.45-2.68C383.75,120.93,384,120.47,384.09,120.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,99c-.17.46-1.9.23-3.93.46s-3.67.78-3.94.36c-.12-.21.17-.65.83-1.1a6.63,6.63,0,0,1,2.93-1,6.46,6.46,0,0,1,3.07.38C382.71,98.38,383.08,98.75,383,99Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.32,99.64c-.31.39-1.49,0-2.93,0s-2.64.25-2.92-.16c-.12-.2.07-.6.61-1a4.24,4.24,0,0,1,4.71.17C399.29,99.05,399.46,99.45,399.32,99.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.65,112.26c-.19-.08-7.72-2.33-7.52,5.36s8.46,6,8.47,5.81S364.65,112.26,364.65,112.26Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.59,120.45s-.13.1-.35.21a1.32,1.32,0,0,1-1,0c-.82-.28-1.54-1.55-1.61-2.94a4.46,4.46,0,0,1,.32-1.93,1.54,1.54,0,0,1,1-1,.67.67,0,0,1,.8.34c.11.22.07.37.11.38s.16-.13.09-.45a.85.85,0,0,0-.32-.47,1,1,0,0,0-.74-.18,1.91,1.91,0,0,0-1.37,1.23,4.59,4.59,0,0,0-.41,2.16c.09,1.55.92,3,2,3.27a1.41,1.41,0,0,0,1.22-.24C362.59,120.64,362.62,120.47,362.59,120.45Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397,88.17c1.22-.73-2.65-4.63-5.76-5.91-4.69-1.94-11.8-3-16-1.63-5.08,1.64-9.25,4.34-11.67,9.1a30.25,30.25,0,0,0-2.85,15.56A9.2,9.2,0,0,0,362,110c1.14,1.67,3.23,2.67,3.23,5a3.18,3.18,0,0,0,.88,2.32c1.46,1.45,3.13,0,3.87-1.45,1.59-3.07,1.65-6.68,1.68-10.13a22.61,22.61,0,0,0-.74-7.3c-.42-1.27-1.07-2.46-1.42-3.75a4.64,4.64,0,0,1,.41-3.86,6.23,6.23,0,0,1,.6-.65,8,8,0,0,1,7.91-1.79c4.38,1.38,11.86,3.41,13.74,1.87,2.7-2.21,3.32-3.61,3.32-3.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.06,99.78a25.85,25.85,0,0,0-12.54-3.63C371.05,96.09,360,103,360,103l-.4-5.38s28.58-5.07,28.77-5.08,8.74,1.58,8.94,1.65,5.26,1,5.26,1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.89,100.87S403.13,92.45,381,95c-23.19,2.65-26.14,8.7-26.14,8.7s-1.67-5.23,2.15-7.85a28.76,28.76,0,0,1,6.53-17.45c2.39-2.76,6.69-5.11,7.59-5.85l.14-1.55s1.63-1.85,9.47-2c8.09-.12,9.7,2.41,9.7,2.41l.18,1.38S403.08,78.63,404,94.71C404,94.71,408.41,97.66,407.89,100.87Z",
    style: {
      fill: "#2568FC"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M371.29,71c1.29,1.54,3.52,4.2,3.92,6.44a45.81,45.81,0,0,1,.5,6.84c-1.33-7.52-2.42-8.61-4.56-11.73Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M357,95.83a1.74,1.74,0,0,1,.44-.21l1.3-.53c.57-.24,1.27-.5,2.1-.76s1.76-.6,2.82-.86a81.07,81.07,0,0,1,16.86-2.71,59.38,59.38,0,0,1,17,1.2c1.05.3,2,.58,2.83.88s1.5.61,2,.9l1.21.73a1.69,1.69,0,0,1,.4.28s-.16,0-.45-.19l-1.24-.64c-.55-.26-1.26-.49-2.06-.81s-1.77-.51-2.82-.79a63.16,63.16,0,0,0-16.9-1,89.39,89.39,0,0,0-16.79,2.55c-1.07.23-2,.55-2.83.78s-1.55.46-2.12.67l-1.33.43A1.5,1.5,0,0,1,357,95.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.29,71a8.43,8.43,0,0,1,1.49,1.48,11.13,11.13,0,0,1,2.65,4.34,15.2,15.2,0,0,1,.57,5,6.45,6.45,0,0,1-.31,2.08,12,12,0,0,1-.06-2.09,18.7,18.7,0,0,0-.7-4.89,12.67,12.67,0,0,0-2.43-4.26A8.35,8.35,0,0,1,371.29,71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.13,76.24a1.51,1.51,0,0,0-.19-1,.89.89,0,0,0-.87-.28,2.73,2.73,0,0,0-.85.43,24.75,24.75,0,0,0-10.13,17.66.4.4,0,0,0,.6.41,27.76,27.76,0,0,1,8.24-3c.94-.2,2.31-.12,2.71-1.11a5.14,5.14,0,0,0,.28-1.88Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M390.81,80.66a26.66,26.66,0,0,1-.17-4.53,26.13,26.13,0,0,1,.07-4.53,16,16,0,0,1,.45,4.53A15.8,15.8,0,0,1,390.81,80.66Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.05,282.15c0-1.12,0-28.34,2.52-42.09s9.54-55.56,12.35-61.74,3.56-7.22,4.83-8.47,10,23.34,9.2,24.19-7.48,43.64-7.48,43.64l-9.64,44.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.15,304.53c-.64.85-4.89,53.38-4.89,53.38l23.53,20.62,15.39.22,3.61-57.21-23-17.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.75,309.24s-.07-7.5,4.08-9.33l1.19,2.14s-1.63,2.45-1.49,7.19C204.53,309.24,202.18,310.51,200.75,309.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.31,281.11c0,.47-.89,6.73-1.14,9.74s-1.87,8.82-1.29,10.44,5.22,7.07,6.61,7.42a5.79,5.79,0,0,0,2.66,0l1.73-.35-1.61-2.43-1-2.55L210.5,298s-.49,6.15,1.38,7.42,2.66.72,2.38-.84.39-7.16.06-10.17-1.85-5.68-1.38-8.24.69-5.1.69-5.1Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.06,299.91s5.48,4.76,3.86,16.36c0,0-3.21,1.44-3.86,0,0,0,1.54-9.56-1.08-12.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.79,321.54a5,5,0,0,1-1,.13l-2.93.19-10.21.51h-.09l-.07-.06-6-4.52c-4.81-3.61-9.14-6.9-12.26-9.3l-3.68-2.86a11.6,11.6,0,0,1-1.31-1.11,10.62,10.62,0,0,1,1.43,1l3.78,2.73c3.18,2.32,7.55,5.57,12.35,9.18l6,4.54-.15-.05,10.21-.32,2.94-.05A5.71,5.71,0,0,1,225.79,321.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,322.26c.14,0-.64,12.66-1.75,28.26s-2.12,28.24-2.27,28.23.64-12.66,1.75-28.27S210.85,322.25,211,322.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,342.76a4.1,4.1,0,0,1-1-.52c-.66-.36-1.59-.91-2.72-1.63a94.75,94.75,0,0,1-8.49-6.1,93,93,0,0,1-7.76-7c-.94-1-1.68-1.75-2.17-2.31a4.77,4.77,0,0,1-.73-.91,5,5,0,0,1,.88.77l2.28,2.19c1.93,1.83,4.66,4.31,7.83,6.86s6.16,4.7,8.36,6.2l2.62,1.77A5.44,5.44,0,0,1,209,342.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,267.42c-.13-.05,29.82,22,29.82,22L290,262l-4.14-8s-24.37,8.8-35,6.59S225.68,254,225.68,254Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.83,448.88v1.2s-20.24,8.35-20.42,12.21l40.34-.6L279,448.28A23.07,23.07,0,0,1,259.83,448.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.76,461.69l-.18-3.22L241,460.22s-1.78.8-1.56,2.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.7,450.19c0,.2,1,.27,2,.89s1.51,1.44,1.69,1.36-.13-1.21-1.33-1.94S259.65,450,259.7,450.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.49,452c0,.2.82.52,1.5,1.34s.89,1.7,1.08,1.69.31-1.13-.56-2.13S255.49,451.82,255.49,452Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.16,457.1c.18,0,.44-1-.08-2s-1.45-1.48-1.53-1.32.5.74.91,1.62S253,457.09,253.16,457.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.14,266.92S213,292,225.12,324s19,57.61,19.42,64.51,2,11.12,8.36,32.95c4.67,15.94,7.69,27.62,7.69,27.62a16.69,16.69,0,0,0,13.77.93s.12-37.37-6.9-63-11.82-65.63-9.42-80.09-2.8-22.69-2.8-22.69Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.4,297.63c4.67-22.52-7.9-40.09-7.9-40.09L250.12,288s-7.91,91.14-3.24,103,27.48,60.62,27.48,60.62L287.74,447s-3.2-35.48-8.68-48.92c-3.05-7.47-9-11.16-6.23-20.52S291.59,316.06,295.4,297.63Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.11,443.82s-10,10.13-15.48,4.55l-1,3.05-3.76,21.44a2.79,2.79,0,0,0,1.94,3.2,2.86,2.86,0,0,0,2.89-.83c3.79-4.25,17.66-20,17.33-21.87l-.55-5.13c-.12-1.06-1.15-3.59-1.15-3.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.32,476.15l19.54-24.58.11,1.12a3.1,3.1,0,0,1-.8,2.57c-1.53,2.48-5.9,8.1-16.39,20a2.84,2.84,0,0,1-2.46.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.47,464a8.15,8.15,0,0,0-2.57-1.84,8.67,8.67,0,0,0-3.18-.3c0-.06.3-.3.93-.44a4.44,4.44,0,0,1,2.47.19,4.38,4.38,0,0,1,2,1.46C275.46,463.61,275.54,464,275.47,464Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.86,467.75a20.85,20.85,0,0,0-2.51-.92,21.77,21.77,0,0,0-2.68-.09c-.09-.13,1.17-.81,2.8-.48S274,467.66,273.86,467.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.66,459.16a27.26,27.26,0,0,0-3.77-1.67c-2.2-.64-4.09-.37-4.12-.55a6.33,6.33,0,0,1,4.29,0C277.42,457.58,278.78,459.07,278.66,459.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.2,372.58a4.16,4.16,0,0,1,0,.84c0,.6,0,1.4-.05,2.4a76.6,76.6,0,0,0,.27,8.79,35.6,35.6,0,0,0,3.44,12.47c1.05,2.23,2.26,4.51,3.44,6.93s2.32,5,3.43,7.57c2.26,5.21,4.58,10.1,6.65,14.58s3.91,8.51,5.36,11.95,2.54,6.25,3.24,8.22c.36,1,.6,1.75.77,2.27a4.18,4.18,0,0,1,.23.81,5,5,0,0,1-.34-.77l-.87-2.23c-.76-1.94-1.9-4.73-3.4-8.14s-3.36-7.43-5.47-11.89-4.44-9.35-6.7-14.58c-1.12-2.62-2.23-5.14-3.41-7.55s-2.37-4.7-3.41-6.94A35.37,35.37,0,0,1,246,384.65a68.51,68.51,0,0,1-.09-8.84c.07-1,.12-1.8.16-2.4A4.91,4.91,0,0,1,246.2,372.58Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,240.68s-16.31,36.5-11,60.73,24,75.49,24,75.49l36.7,1.85s16.09-52.57,19.39-67.83c4.37-20.15,5.46-38.65-7.43-64.89l-2.79-8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,376.63a1.16,1.16,0,0,1,0-.28v-.8c0-.76.06-1.8.11-3.11.12-2.75.3-6.63.52-11.41.49-9.68,1.17-23,1.92-37.64.72-13,1.39-25,1.89-34.08l0,.14-7.78-11.64-2.1-3.21-.54-.84a1.42,1.42,0,0,1-.16-.3s.08.08.22.26l.59.81,2.2,3.13,7.95,11.53.05.06v.08c-.47,9.13-1.08,21.06-1.75,34.09-.82,14.67-1.56,28-2.1,37.63-.3,4.78-.54,8.66-.71,11.4-.09,1.31-.16,2.34-.22,3.1,0,.33,0,.59-.07.81A.84.84,0,0,1,245,376.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.48,165.42a17.2,17.2,0,0,1,5.45,7.54c3.77,9.43,13,41.35,13.21,43.47.3,3.12,2.36,10.69,1.11,14.72s-12.77,7.22-12.77,7.22L294.9,224.2l2-2.24-11.32-28.74V177.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.27,219.57c0,.08-.77-.2-2-.4a12.86,12.86,0,0,0-4.88.17,12.68,12.68,0,0,0-4.44,2c-1,.73-1.57,1.32-1.64,1.26a4.92,4.92,0,0,1,1.41-1.55,11.34,11.34,0,0,1,9.62-2.25A4.85,4.85,0,0,1,309.27,219.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.91,159c-.84.21-19.7,7.45-20.75,12.26s6.89,21.26,6.89,21.26-4.48,10.21,0,17.44c0,0-5,28.37-5.75,36a7.55,7.55,0,0,0,0,2.25c2,1.74,67.09,1.61,67.72.36s-5.31-39.9-4.47-43.25,0-12.12,0-12.12,8.78-27.17,7.94-27.8-24.19-8.35-24.19-8.35l-3.68-.71L246.91,158Z",
    style: {
      fill: "#2568FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223,240.51s63.07-.21,63.3.27,1.47,6.82,1.47,6.82l-65.52-1.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.6,230.1s60.75.18,61,.66.93,5.08.93,5.08l-62.92.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.84 160.2 241.91 159.02 245.39 155 267.24 152.84 270.04 156.52 275.34 158.78 255.45 188.17 238.84 160.2",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.62,175.7l51.49,77.35s.39,12.84-12.26,10l-56.34-76.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.62,175.7l-.3.21-.86.57-3.34,2.2-12.53,8.17,0-.21c12.15,16.41,32.43,43.82,55.4,74.84l1,1.38-.15-.09c.79.11,1.57.27,2.35.35l1.17,0H303l.57-.08a7.21,7.21,0,0,0,4.14-1.79,8.91,8.91,0,0,0,2.4-3.79,14.1,14.1,0,0,0,.74-4.43l0,.13L274.3,198l-10.78-16.33c-1.26-1.91-2.23-3.4-2.9-4.42l-.75-1.15-.25-.41s.09.11.26.36l.76,1.11,2.92,4.33,10.88,16.21,36.88,55.2.05.06v.08a14.5,14.5,0,0,1-.76,4.6,9.34,9.34,0,0,1-2.55,4,7.59,7.59,0,0,1-4.41,1.92l-.61.09h-.61l-1.23,0c-.8-.08-1.6-.24-2.41-.37h-.09l-.06-.09-1-1.38-55.22-75-.1-.13.14-.08,12.69-8.08,3.35-2.12.86-.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.81,229.24a8.84,8.84,0,0,1,.15-1.48c.16-1,.36-2.38.61-4,.56-3.52,1.34-8.31,2.22-13.78l0,.16a18.19,18.19,0,0,1-1.78-5.33,21.85,21.85,0,0,1,1.81-12.33v.2c-1.51-3.41-2.79-6.27-3.71-8.36-.42-1-.75-1.74-1-2.35a4.68,4.68,0,0,1-.32-.86,3.66,3.66,0,0,1,.44.8l1.13,2.3c1,2.08,2.3,4.91,3.88,8.28l0,.09-.05.11a21.68,21.68,0,0,0-1.69,12,18,18,0,0,0,1.7,5.18l0,.08V210c-.95,5.46-1.79,10.24-2.4,13.75l-.75,4A10.8,10.8,0,0,1,224.81,229.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.53,196.22a10.07,10.07,0,0,1,.45-2.31c.36-1.41.94-3.34,1.71-5.43s1.58-3.93,2.22-5.24a9.19,9.19,0,0,1,1.16-2.06,13,13,0,0,1-.83,2.21c-.55,1.34-1.3,3.2-2.06,5.27s-1.4,4-1.84,5.35A10.88,10.88,0,0,1,284.53,196.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 251.06,
    cy: 181.21,
    rx: 10.18,
    ry: 7.34,
    transform: "matrix(0.84, -0.54, 0.54, 0.84, -58.14, 164.89)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.62,175.7a8.86,8.86,0,0,0-1.57-1.46,8.17,8.17,0,0,0-5.62-1,13.62,13.62,0,0,0-7.55,3.92,11.13,11.13,0,0,0-2.64,4.29,5.61,5.61,0,0,0,5,7.72,11.11,11.11,0,0,0,5-.63,13.69,13.69,0,0,0,6.69-5.26,8.16,8.16,0,0,0,1.39-5.53,9.23,9.23,0,0,0-.68-2,2.83,2.83,0,0,1,.32.47,5.8,5.8,0,0,1,.56,1.53,8.19,8.19,0,0,1-1.28,5.76,13.87,13.87,0,0,1-6.84,5.51,11.57,11.57,0,0,1-5.22.69,6.11,6.11,0,0,1-5.4-8.39,11.39,11.39,0,0,1,2.78-4.46,13.76,13.76,0,0,1,7.85-3.95,8.1,8.1,0,0,1,5.77,1.21,5.41,5.41,0,0,1,1.16,1.14A2.73,2.73,0,0,1,259.62,175.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.58,261.76c-.12.08-12-16.5-26.48-37S254.92,187.46,255,187.38s12,16.5,26.48,37S307.7,261.67,307.58,261.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.53,249.78c-.15,0,.05-11,.44-24.61s.82-24.6,1-24.59-.05,11-.44,24.61S251.67,249.78,251.53,249.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.05,165.5a9,9,0,0,1-1.14,2,28.58,28.58,0,0,1-3.72,4.45l-.21.2-.17-.24c-.61-.85-1.26-1.78-1.92-2.76-1.77-2.61-3.28-5-4.32-6.82a18.94,18.94,0,0,1-1.56-3,24.31,24.31,0,0,1,1.88,2.76c1.12,1.73,2.66,4.12,4.43,6.72.66,1,1.3,1.9,1.9,2.76l-.38,0a36.3,36.3,0,0,0,3.82-4.27A15.62,15.62,0,0,1,255.05,165.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.22,157.8a26.29,26.29,0,0,1-2.06,2.88c-1.33,1.74-3.19,4.12-5.27,6.72l-3.17,3.95-.18.23-.19-.22c-1.33-1.59-2.44-2.94-3.21-3.91a10,10,0,0,1-1.16-1.57,9.49,9.49,0,0,1,1.37,1.39c.84.91,2,2.22,3.36,3.78h-.36l3.14-4c2.08-2.61,4-5,5.38-6.63A22.68,22.68,0,0,1,270.22,157.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.28,225.71a1.83,1.83,0,0,1,1-3.27,7.87,7.87,0,0,1,1.4.07c2.73.34,8.95,2,10.88,1.68s3.58-.94,4.52-2.52-2.81-7.19-2.39-9.92,2.09-2,2.54-1.36,2.92,5,4,6.61,6.07,7.22,7.85,7.75,2.89.8,2.89.8a6.25,6.25,0,0,1,4,4.32c.76,3.32-2.11,7.06-4.67,7s-21.39.84-22.41.16-3.14-2-3.48-4c0,0-4.43-1.93-4.52-3.38,0,0,.1-2.69.06-3A5.7,5.7,0,0,1,268.28,225.71Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.23,228.67a20.7,20.7,0,0,1-5.44-.74,20.16,20.16,0,0,1-5.23-1.66,49.63,49.63,0,0,1,5.35,1.16A47.87,47.87,0,0,1,280.23,228.67Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,232.76a5.91,5.91,0,0,1-1.95.1,26.16,26.16,0,0,1-9.17-2.07,5.92,5.92,0,0,1-1.73-.93c.07-.14,2.78,1.08,6.33,1.87S283,232.6,283,232.76Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.39,234.89a15,15,0,0,1-4.71-.36,14.88,14.88,0,0,1-4.52-1.34,39.71,39.71,0,0,1,4.62.82A39.7,39.7,0,0,1,283.39,234.89Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.76,132.44c-2.35-2.33-6.24-3.43-9-1.66l-9.33,9.29a10.78,10.78,0,1,0,18.37-7.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.55,115.78a6.22,6.22,0,0,0-3.16-2.88c-13.57-5.35-29.26-5-43.44-1.21-3.69,1-7.64,2.44-9.4,5.55l0,.21c-.76,2,.36,4.66,2.08,6.13a15.48,15.48,0,0,0,6.29,2.83c10.8,2.8,22.32,2.16,33.43.64a39,39,0,0,0,7.68-1.62,14,14,0,0,0,6.34-4.14A4.67,4.67,0,0,0,281.55,115.78Z",
    style: {
      fill: "#2568FC"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M281.55,115.78a6.22,6.22,0,0,0-3.16-2.88c-13.57-5.35-29.26-5-43.44-1.21-3.69,1-7.64,2.44-9.4,5.55l0,.21c-.76,2,.36,4.66,2.08,6.13a15.48,15.48,0,0,0,6.29,2.83c10.8,2.8,22.32,2.16,33.43.64a39,39,0,0,0,7.68-1.62,14,14,0,0,0,6.34-4.14A4.67,4.67,0,0,0,281.55,115.78Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M274,106.59a26.39,26.39,0,0,0-20.43-10.17c-4.64-.08-6.56.89-9.9,1.79a14.63,14.63,0,0,0-8.35,5.52c-2.37,3.36-4.36,7.13-4.8,11.21a69.51,69.51,0,0,0-.61,12.64,23,23,0,0,0,3.94,11.86l10.72,1.87c5.91.2,11.91.39,17.67-1s11.37-4.45,14.46-9.5C281,123.83,279.2,113,274,106.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.46,106.52l-14.28-5.68-3.73.43c-8.4,0-14.19,9.29-14.24,16.09-.06,7.56.16,16.78,1.36,22.35,2.42,11.2,12,12.13,12,12.13a38.13,38.13,0,0,0-.16,4.09l9.48,10,12.36-12.24,1-43.36A4,4,0,0,0,264.46,106.52Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.37,137.09a2.45,2.45,0,0,0-3.78-1.64,3.26,3.26,0,0,0-1.24,3.06h0a3,3,0,0,0,2.12,1.23,2.77,2.77,0,0,0,2.19-.69A2.38,2.38,0,0,0,250.37,137.09Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.44,126.09a1.44,1.44,0,0,0,1.48,1.38,1.38,1.38,0,0,0,1.42-1.38,1.44,1.44,0,0,0-1.47-1.39A1.4,1.4,0,0,0,237.44,126.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.77,121.14c.19.18,1.24-.69,2.8-.78s2.74.64,2.9.44-.12-.42-.64-.76a4,4,0,0,0-2.33-.58,3.83,3.83,0,0,0-2.22.85C234.82,120.71,234.68,121.06,234.77,121.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.79,133.36a10.36,10.36,0,0,0-2.56-.31c-.4,0-.78-.08-.86-.35a2,2,0,0,1,.2-1.19c.32-1,.65-2,1-3.1,1.39-4.4,2.38-8,2.21-8.07s-1.46,3.47-2.86,7.87c-.33,1.09-.65,2.12-1,3.11a2.4,2.4,0,0,0-.12,1.58,1,1,0,0,0,.69.54,2.41,2.41,0,0,0,.68.06A10,10,0,0,0,244.79,133.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.52,151.83A28.8,28.8,0,0,0,260.43,147s-3.6,8-15,7.61Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.43,134.19c-.25,0-.16,1.69-1.55,3s-3.19,1.19-3.19,1.43.42.31,1.18.29a4.25,4.25,0,0,0,2.67-1.1,3.66,3.66,0,0,0,1.19-2.49C249.76,134.58,249.55,134.17,249.43,134.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.3,115.68c.28.37,1.46,0,2.86.09s2.58.34,2.87,0c.12-.18-.05-.54-.55-.89a4.43,4.43,0,0,0-4.62-.06C235.35,115.14,235.18,115.5,235.3,115.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.86,125.43a1.45,1.45,0,0,1-1.37,1.49,1.39,1.39,0,0,1-1.52-1.28,1.45,1.45,0,0,1,1.37-1.49A1.38,1.38,0,0,1,254.86,125.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.86,120.54c-.17.19-1.29-.61-2.85-.57s-2.69.83-2.86.64.09-.43.58-.8a4,4,0,0,1,2.29-.75,3.84,3.84,0,0,1,2.28.69C255.78,120.11,256,120.45,255.86,120.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.93,115.54c-.3.36-1.52,0-3,0s-2.67.29-3-.08c-.13-.18.06-.54.59-.88A4.48,4.48,0,0,1,252,114a4.37,4.37,0,0,1,2.38.67C254.88,115,255.06,115.37,254.93,115.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.3,129.33c-.05-.84.82-2.88,1.64-3.05,2.2-.47,6.21-.51,6.56,5.12.47,7.7-7.36,6.59-7.38,6.37S266.45,132.24,266.3,129.33Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.07,134.82s.14.09.37.18a1.35,1.35,0,0,0,1,0c.8-.35,1.4-1.68,1.35-3.07a4.45,4.45,0,0,0-.49-1.9,1.56,1.56,0,0,0-1.07-1,.69.69,0,0,0-.77.42c-.09.22,0,.37-.07.39s-.17-.12-.13-.44a.81.81,0,0,1,.27-.5,1,1,0,0,1,.73-.25,1.9,1.9,0,0,1,1.48,1.11,4.52,4.52,0,0,1,.59,2.12c.05,1.55-.66,3-1.75,3.44a1.46,1.46,0,0,1-1.24-.12C269.09,135,269,134.84,269.07,134.82Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.26,126.3l-2,2c-8.45-8.08-25-28.33-24-27.12a24.58,24.58,0,0,1,12.07-1.31c6.28,1.07,18.19,4.21,18,11.62S268.26,126.3,268.26,126.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.68,124.6a1.35,1.35,0,0,0-.11-.44,7.92,7.92,0,0,0-.51-1.22,11.34,11.34,0,0,0-3.15-3.62,20.38,20.38,0,0,0-6.34-3.11,85.66,85.66,0,0,1-8.16-2.72,36.12,36.12,0,0,1-7.44-4.26,38.83,38.83,0,0,1-5.25-4.69,40.42,40.42,0,0,1-3-3.68l-.76-1.06a1.57,1.57,0,0,0-.28-.36,2.18,2.18,0,0,0,.22.4c.15.25.38.64.69,1.11a35.34,35.34,0,0,0,3,3.78,36.52,36.52,0,0,0,5.24,4.8,36.07,36.07,0,0,0,7.51,4.33,79.39,79.39,0,0,0,8.19,2.69,20.63,20.63,0,0,1,6.28,3,11.21,11.21,0,0,1,3.18,3.47C278.48,124,278.65,124.62,278.68,124.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.49,125.81a4.05,4.05,0,0,0-.29-1.68,7.82,7.82,0,0,0-2.83-3.62,16.81,16.81,0,0,0-6.29-2.52,36.51,36.51,0,0,1-7.81-2.53,32.93,32.93,0,0,1-7-4.4,34.69,34.69,0,0,1-4.78-4.79,38.91,38.91,0,0,1-2.66-3.74l-.64-1.08a2.13,2.13,0,0,0-.24-.36,1.73,1.73,0,0,0,.17.4c.16.29.35.66.58,1.12a32.05,32.05,0,0,0,2.58,3.83,32.76,32.76,0,0,0,4.77,4.9,31.69,31.69,0,0,0,7,4.47,35.11,35.11,0,0,0,7.89,2.53,17.26,17.26,0,0,1,6.21,2.39,8,8,0,0,1,2.85,3.46A9.16,9.16,0,0,1,276.49,125.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.35,116.45a32.41,32.41,0,0,1,14-3.79c21.92-.51,34.54,5.94,34.54,5.94a42,42,0,0,0-1-5.47s-31-4-31.21-4-9.78,1.72-10,1.8-5.9,1-5.9,1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.38,117.61s2.81-6.33,27.66-6.3c24.17,0,29.31,6.88,29.31,6.88a7.71,7.71,0,0,0-4.45-6.61,26.66,26.66,0,0,0-7.2-16.68c-2.54-2.6-7.05-4.78-8-5.46L262.52,88s-1.74-1.75-9.85-1.69c-8.38.07-10,2.55-10,2.55l-.15,1.34a25.07,25.07,0,0,0-13.31,21.43S224.76,114.53,225.38,117.61Z",
    style: {
      fill: "#2568FC"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M243.65,94.5a22.87,22.87,0,0,0-1-5.69l-.15,1.34a65.08,65.08,0,0,1,1.26,11C243.8,98.9,243.8,96.67,243.65,94.5Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M262.52,87.94c-1.3,1.52-3.54,4.14-3.89,6.3a39.37,39.37,0,0,0-.35,6.61c1.18-7.29,2.28-8.35,4.43-11.41Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M277.9,111.58a1.81,1.81,0,0,1-.5-.1l-1.4-.39c-.6-.18-1.34-.39-2.21-.59s-1.85-.49-3-.69a98.41,98.41,0,0,0-17.41-2.06A69.84,69.84,0,0,0,236,109.12c-1.08.29-2.06.55-2.91.83s-1.55.57-2.12.82l-1.29.66a2.75,2.75,0,0,1-.47.2s.14-.12.42-.29l1.25-.75c.56-.29,1.29-.56,2.12-.92s1.83-.6,2.91-.9a64.9,64.9,0,0,1,17.54-1.54,89.43,89.43,0,0,1,17.48,2.22c1.1.23,2.08.54,2.94.77a21.23,21.23,0,0,1,2.2.68l1.37.48A3.32,3.32,0,0,1,277.9,111.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.52,88a8.69,8.69,0,0,1-1.19,1.66,12,12,0,0,0-2.42,4.11,16.33,16.33,0,0,0-.62,4.78,12.14,12.14,0,0,1,0,2,5.83,5.83,0,0,1-.37-2,13.78,13.78,0,0,1,.49-4.94,10.62,10.62,0,0,1,2.64-4.2A7.4,7.4,0,0,1,262.52,88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.9,100.73c-.15,0-.18-2.7-.53-6s-.84-6-.7-6a21.39,21.39,0,0,1,1.22,5.93A21.05,21.05,0,0,1,243.9,100.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.15,92.87a1.39,1.39,0,0,0-.22-.93,1,1,0,0,0-.9-.25,2.47,2.47,0,0,0-.87.44,23.5,23.5,0,0,0-10.06,17.26.42.42,0,0,0,.64.38,29.94,29.94,0,0,1,8.45-3.13c1-.21,2.38-.17,2.78-1.13a4.67,4.67,0,0,0,.24-1.82Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.6,
    y: 267.66,
    width: 3.61,
    height: 27.99,
    transform: "translate(-134.34 61.93) rotate(-30)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.72,264.31l.13,4.09-3.4,2-3.52-2.19a5.19,5.19,0,1,0,9.58-1.57A5.22,5.22,0,0,0,42.72,264.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.98,
    y: 270.25,
    width: 3.1,
    height: 24.04,
    transform: "translate(-133.3 67.09) rotate(-30)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.65,267.37l.11,3.52-2.92,1.68-3-1.87a4.45,4.45,0,1,0,5.83-3.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,159.11s.57-2,6.9-4.34,21.52-7.59,21.52-7.59,3.56,5.27,13.08,5.72c8.72.42,13.85-6.54,13.85-6.54s26.63,6.76,26.66,7.4-3.52,41.46-3.52,41.46l-4.76,48.14-65.26,1-.77-47.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.74,158.11C62.1,158.57,42.33,195,42.33,195s18.19,12.61,22.35,12.89l5.2-9.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,153.76l.67.47a33.88,33.88,0,0,1,9,9.14l16.78,25.25-20.51,14.66L141,189l-3.46-15.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,165.18a3.86,3.86,0,0,1-.09,1l-.43,2.81c-.36,2.36-.84,5.64-1.25,9.26s-.68,6.93-.85,9.32c-.08,1.1-.15,2-.21,2.83a3.39,3.39,0,0,1-.14,1,4.77,4.77,0,0,1-.06-1c0-.67,0-1.64,0-2.84.08-2.4.29-5.71.7-9.35s1-6.92,1.41-9.28c.23-1.17.43-2.12.59-2.78A4.72,4.72,0,0,1,144,165.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.51,169.12c.15,0,.83,7.15,1.54,16s1.15,16,1,16-.83-7.14-1.53-16S67.37,169.14,67.51,169.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.64,100.16a4.82,4.82,0,0,1-1.91-9.4,5,5,0,0,1,4.5-8.39,6,6,0,0,1,9.12-4.78,6.74,6.74,0,0,1,8.3,0,4.8,4.8,0,0,1,4.12,8.2",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.62,82.31h-1.06a20.44,20.44,0,0,0-20.63,18.52c-.93,9.87-1.83,20.78-1.84,26.08,0,11,10.94,12.83,10.94,12.83L89.92,152.9l26.64-.46,3-47.78C120.7,93.28,115,83.13,103.62,82.31Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.94,139.71a26.58,26.58,0,0,0,14.43-4s-3.49,7.85-14.42,6.72Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.23,110.78a1.58,1.58,0,0,0,1.49,1.61,1.51,1.51,0,0,0,1.64-1.4,1.57,1.57,0,0,0-1.49-1.6A1.51,1.51,0,0,0,86.23,110.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.21,106.22c.19.21,1.39-.65,3.08-.63s2.91.89,3.1.69-.11-.46-.64-.86a4.26,4.26,0,0,0-2.47-.8,4.15,4.15,0,0,0-2.46.75C84.3,105.76,84.12,106.13,84.21,106.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.6,110.65a1.56,1.56,0,0,0,1.49,1.6,1.5,1.5,0,0,0,1.64-1.39,1.57,1.57,0,0,0-1.49-1.6A1.51,1.51,0,0,0,101.6,110.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.78,106.76c.2.21,1.4-.65,3.08-.63s2.91.89,3.1.69-.1-.47-.64-.86a4.26,4.26,0,0,0-2.47-.8,4.15,4.15,0,0,0-2.46.75C100.87,106.3,100.69,106.67,100.78,106.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.49,119.18a11.42,11.42,0,0,0-2.73-.53c-.43-.05-.83-.14-.9-.43a2.22,2.22,0,0,1,.3-1.28l1.32-3.26c1.83-4.64,3.16-8.46,3-8.54s-1.83,3.64-3.66,8.28l-1.26,3.28a2.51,2.51,0,0,0-.25,1.69,1.08,1.08,0,0,0,.7.64,2.59,2.59,0,0,0,.73.11A10.34,10.34,0,0,0,94.49,119.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.41,100.25c.22.43,1.67,0,3.45,0s3.27.28,3.44-.16c.07-.21-.24-.6-.88-1a5.34,5.34,0,0,0-2.66-.6,5.19,5.19,0,0,0-2.58.75C99.58,99.64,99.31,100.05,99.41,100.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.23,99.27c.35.39,1.74,0,3.42,0s3.08.3,3.42-.1c.14-.19-.08-.58-.69-1a5.49,5.49,0,0,0-2.77-.66,5.36,5.36,0,0,0-2.74.73C84.27,98.69,84.07,99.08,84.23,99.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.05,95.8s3-6.83,6.32-8.39c4-1.88,5.71,2.54,9.54,1.53s7.7-2.83,11.56.18c4.24,3.29,2.2,5.53,2.4,10.4.8,19.76,4.33,25.39,5.48,16.1.13-1,3-1.79,3.44-6.08.62-5.58.93-12.35-.26-16.33-1-3.35-2.88-5.68-6.26-8.27-5.33-4.09-12.73-4.27-17.76-3.84S82.71,87.19,83.05,95.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.66,115.31a3,3,0,0,1,3.25-2.82c2,.22,4.31,1.41,4.12,5.64-.35,7.5-7.8,5.61-7.81,5.39S117.49,118.45,117.66,115.31Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,120.78s.13.09.35.21a1.33,1.33,0,0,0,1,.06c.81-.25,1.53-1.48,1.63-2.83a4.3,4.3,0,0,0-.28-1.89,1.52,1.52,0,0,0-.94-1,.68.68,0,0,0-.79.33c-.11.2-.06.35-.1.37s-.16-.14-.09-.45a.86.86,0,0,1,.32-.45,1,1,0,0,1,.73-.16,1.83,1.83,0,0,1,1.31,1.23,4.38,4.38,0,0,1,.36,2.11c-.12,1.5-1,2.88-2,3.15a1.41,1.41,0,0,1-1.19-.26C119,121,119,120.79,119,120.78Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.71,100.78a7.11,7.11,0,0,1-3.2,1.42,2.45,2.45,0,0,1-2.69-1.76c-.08-.52.05-1.12-.28-1.53s-1.16-.35-1.79-.29c-2.19.2-4.7-2.24-5.23-4.37a2,2,0,0,1-2.62.51,7.14,7.14,0,0,1-1.79-1.63,3.07,3.07,0,0,0-2.56-1.33,7.28,7.28,0,0,1-1.63.34c-1-.1-1.45-1.26-1.59-2.24s-.24-2.12-1.06-2.67-1.77-.23-2.68-.11-2.08-.1-2.3-1a1.78,1.78,0,0,1,.35-1.36A4.86,4.86,0,0,1,94.4,83a6.59,6.59,0,0,1,12.12-1.11,6.68,6.68,0,0,1,10.65,2.58,4.84,4.84,0,0,1,5.37,7.12A4.62,4.62,0,0,1,125,95.29c0,1.56-1.53,3.08-3,2.66a2.68,2.68,0,0,1-4.68,2.61",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.82,85.21s0,.05,0,.14a2.51,2.51,0,0,0,0,.4,4.84,4.84,0,0,0,.52,1.45A5.42,5.42,0,0,0,96,89a5.05,5.05,0,0,0,3.06.91L99,89.75a2.72,2.72,0,0,0,.12,2.07,8,8,0,0,0,1.26,1.86,5.6,5.6,0,0,0,.83.87,2.63,2.63,0,0,0,1.18.46,2.75,2.75,0,0,0,2.43-.83l-.28-.09A5.64,5.64,0,0,0,106.83,98a4.17,4.17,0,0,0,2.45.84,7.52,7.52,0,0,0,2.44-.5l-.2-.09a6,6,0,0,0,1.74,2.34,3.2,3.2,0,0,0,2.61.75,4.13,4.13,0,0,0,3.22-3.19l-.17.07a3.91,3.91,0,0,0,2.57.42,4.21,4.21,0,0,0,1.81-.78,3.38,3.38,0,0,0,.85-.91,1.55,1.55,0,0,0,.2-.38,4.78,4.78,0,0,1-1.12,1.19,4.26,4.26,0,0,1-1.76.7A3.74,3.74,0,0,1,119,98L118.9,98l0,.16a3.92,3.92,0,0,1-3.05,3,2.89,2.89,0,0,1-2.37-.71,5.76,5.76,0,0,1-1.64-2.22l0-.14-.14,0a7.45,7.45,0,0,1-2.33.48,3.84,3.84,0,0,1-2.27-.79,5.31,5.31,0,0,1-2.21-3.7l0-.35-.24.27a2.45,2.45,0,0,1-2.14.74,2.53,2.53,0,0,1-1-.4,5.56,5.56,0,0,1-.78-.82,7.79,7.79,0,0,1-1.23-1.78,2.53,2.53,0,0,1-.14-1.88l.07-.18h-.19a4.75,4.75,0,0,1-2.93-.83,5.27,5.27,0,0,1-1.63-1.7A5.65,5.65,0,0,1,93.82,85.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.78,125c0-.28,1.89.13,3.55-1.15s1.9-3.28,2.16-3.24.26.52.1,1.35a4.77,4.77,0,0,1-1.7,2.73,4.08,4.08,0,0,1-3,.84C95.15,125.39,94.75,125.08,94.78,125Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.37 202.07 75.33 181.9 132.35 181.72 138.46 247.12 69.48 249.82 73.37 202.07",
    style: {
      fill: "#2568FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.45,152.09c-.41.59,3.18,27.68,3.18,27.68l9-.35-3-30.8S77.84,148.62,75.45,152.09Z",
    style: {
      fill: "#2568FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.28,150.26c.57.44-2.88,29.69-2.88,29.69l-9-.35L123,147.73S128.36,147.23,132.28,150.26Z",
    style: {
      fill: "#2568FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.14,427.29,90,448.6s-21.38,8-21.61,11.93l41.36-.09.1-33.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.7,460.44l-.12-3.35L70,458.43s-1.84.8-1.63,2.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9,448.51c0,.2,1,.29,2,.93s1.53,1.5,1.71,1.42-.12-1.25-1.34-2S89.85,448.32,89.9,448.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.18,450.56c-.05.19.83.53,1.52,1.39s.88,1.75,1.08,1.74.33-1.15-.54-2.19S85.18,450.36,85.18,450.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.49,455.82c.19,0,.47-1,0-2.07s-1.47-1.55-1.56-1.38.5.76.92,1.67S82.29,455.8,82.49,455.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9,443.51c.09.19,1-.09,2.16,0s2,.44,2.13.26-.75-.89-2.1-1S89.8,443.36,89.9,443.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.8,424.74l2.24,25.7L135,471.28a2.64,2.64,0,0,0,2.26,3.13h0a2.62,2.62,0,0,0,2.27-.83c3.69-4,17.18-18.87,16.91-20.75-.32-2.16-.57-27.26-.57-27.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.21,474.41l19.07-23.31.07,1.09a4,4,0,0,1-.78,2.63c-1.51,2-5.81,7.53-16,18.76a2.65,2.65,0,0,1-2.35.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.37,462.78a5.74,5.74,0,0,0-5.39-2.23c0-.06.29-.28.89-.41a4.23,4.23,0,0,1,2.33.26,4,4,0,0,1,1.83,1.47C142.37,462.38,142.43,462.76,142.37,462.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.76,466.35a21.45,21.45,0,0,0-2.35-1,22.23,22.23,0,0,0-2.54-.17,2.94,2.94,0,0,1,2.66-.38C140.08,465.18,140.89,466.27,140.76,466.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.5,458.15a25.32,25.32,0,0,0-3.53-1.73c-2.06-.68-3.86-.47-3.87-.65a7.24,7.24,0,0,1,7.4,2.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.47,450.28c-.06.16-1.52-.35-3.37-.29s-3.29.59-3.36.43a6.55,6.55,0,0,1,6.73-.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.23,445.2a12.84,12.84,0,0,0-3.5-.4,12.58,12.58,0,0,0-3.36,1.08c0-.05.22-.39.79-.78a5.56,5.56,0,0,1,2.51-.86,5.73,5.73,0,0,1,2.64.35C145,444.86,145.27,445.14,145.23,445.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.56,254.53a91.51,91.51,0,0,0-2,26.94c.44,5.72,19.76,164.09,19.76,164.09H111.4l-7.33-148.84,2.14.46s14.23,63.48,15.4,73.76c1,9.24,13,76.36,13,76.36l23.84.27-7.61-88.78L142,273.61l-3.34-24.8Z",
    style: {
      fill: "#2568FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98,265.89a6.16,6.16,0,0,1,.18,1.23c.09.9.19,2,.32,3.35.27,2.82.66,6.73,1.17,11s1.06,8.18,1.46,11c.19,1.32.35,2.44.48,3.33a5.65,5.65,0,0,1,.11,1.23,5.5,5.5,0,0,1-.31-1.2c-.17-.77-.39-1.9-.64-3.3-.5-2.8-1.1-6.68-1.62-11s-.84-8.23-1-11.06c-.09-1.42-.14-2.57-.16-3.37A5.52,5.52,0,0,1,98,265.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.62,186a2.2,2.2,0,1,1-2.2-2.2A2.19,2.19,0,0,1,85.62,186Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.16,186a2.2,2.2,0,1,1-2.19-2.2A2.19,2.19,0,0,1,127.16,186Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.23,
    y: 179.42,
    width: 9.83,
    height: 1.71,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,180.89a7.54,7.54,0,0,1-.39,2.37,12.56,12.56,0,0,1-.93,2.46,5.47,5.47,0,0,1-.9,1.31,2.25,2.25,0,0,1-1.6.81,2.17,2.17,0,0,1-1.59-.83,6.89,6.89,0,0,1-.88-1.32,14.63,14.63,0,0,1-1-2.44,6.89,6.89,0,0,1-.46-2.36c.06,0,.3.87.81,2.24a17.81,17.81,0,0,0,1,2.33,6.49,6.49,0,0,0,.84,1.2,1.73,1.73,0,0,0,1.2.66,1.82,1.82,0,0,0,1.24-.64,5.4,5.4,0,0,0,.85-1.19,15,15,0,0,0,1-2.33A20.77,20.77,0,0,1,87,180.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 179.36,
    width: 9.83,
    height: 1.71,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.75,180.84a7.54,7.54,0,0,1-.39,2.37,12.74,12.74,0,0,1-.93,2.45,5.47,5.47,0,0,1-.9,1.31,2.25,2.25,0,0,1-1.6.81,2.17,2.17,0,0,1-1.59-.83,6.89,6.89,0,0,1-.88-1.32,14.63,14.63,0,0,1-1-2.44,6.89,6.89,0,0,1-.46-2.35c.06,0,.3.86.81,2.23a17.24,17.24,0,0,0,1,2.33,6.91,6.91,0,0,0,.84,1.21,1.71,1.71,0,0,0,1.21.65,1.78,1.78,0,0,0,1.23-.64,5.35,5.35,0,0,0,.85-1.18,15,15,0,0,0,1-2.34A19.17,19.17,0,0,1,128.75,180.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.62,205.26c0-.22,3-6.08,6.38-7.35s6.36-.19,9.09.83l6.65,3.18,2.39-.16,7,4-8.27,12.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.44,223.47c-.15.17-4.32,5.14-6.25,5.15s15.25,9.49,15.25,9.49a5,5,0,0,1-1.57-4.55,15.4,15.4,0,0,1,2.68-5.87l12.74-10.44-14.17-7.91S86.69,219.5,83.44,223.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.5,
    y: 231.45,
    width: 25.13,
    height: 10.39,
    transform: "translate(129.45 -9.83) rotate(30)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.93,216.93l13.45,5.12,4.24-7.08L115.19,207s-3.28-.66-5.43,3.1A8.85,8.85,0,0,0,108.93,216.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.77,217c-1.06,2-.8,4.27.57,5s3.35-.35,4.41-2.38.81-4.27-.56-5S122.84,215,121.77,217Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.08,218.62c-.46,1.1-.24,2.24.5,2.56s1.72-.33,2.18-1.42.24-2.24-.5-2.56S125.54,217.53,125.08,218.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.15,220.06c0,.09,10.84,4.73,10.84,4.73l.56-1.3-10.42-5A1.22,1.22,0,0,0,126.15,220.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.22,214.66c0,.08-.49.23-1.18.68a5.66,5.66,0,0,0-2.07,2.37,5.72,5.72,0,0,0-.38,3.13,12.13,12.13,0,0,1,.29,1.33s-.41-.4-.65-1.26a5.13,5.13,0,0,1,2.62-5.89C125.65,214.62,126.21,214.6,126.22,214.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.19,207a12.52,12.52,0,0,0-1.94.35,6.9,6.9,0,0,0-3.4,3.09,10,10,0,0,0-1,4.56c0,1.23.23,2,.15,2a3.78,3.78,0,0,1-.52-2,10.22,10.22,0,0,1,.1-2.22,7.5,7.5,0,0,1,.85-2.62,8.59,8.59,0,0,1,1.76-2.11,5.39,5.39,0,0,1,2-1.07A3.13,3.13,0,0,1,115.19,207Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.74,202.07a49.35,49.35,0,0,0-4.11,2.88,47.14,47.14,0,0,0-3.41,3.69,10,10,0,0,1,3.07-4.08A10.14,10.14,0,0,1,106.74,202.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.09,197.84c.07.49-7.14,15.69-5.64,22.15S50.81,231.46,56.7,230.1s18.83-7.54,18.83-7.54l.93-12.5-17,.09h0l1.22-3.78Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.09,221.33a24.32,24.32,0,0,0-3.3-5c-1.83-2-8.93-6.58-11.86-7.44s-16.47,1.21-16.47,1.21l-.93,12.5,3.09.95a12.55,12.55,0,0,0,6,2.87c3.43.49,8.22,4,9.14,3.78S95.44,228,95.44,228s3.16,1.53,3.53-2c0,0,2.77-.62,2.69-2.58s-4.81-6.74-4.81-6.74a18.87,18.87,0,0,1,5.62,3.61c1.94,2.09,4.17,3.66,4.88,3.11a2.38,2.38,0,0,0,.76-1.58",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.32,225.86c-.13.09-1.29-1.41-3-2.94s-3.38-2.52-3.3-2.65a12.9,12.9,0,0,1,6.34,5.59Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.18,228.66a30.45,30.45,0,0,0-3.13-2.77c-.94-.64-1.94-1.06-2.54-1.6s-.8-1-.74-1,.33.35,1,.76,1.6.78,2.61,1.46A7,7,0,0,1,96.18,228.66Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.27,210.32a19,19,0,0,1-2-.76,16.29,16.29,0,0,0-5-.93,16.08,16.08,0,0,0-5,.68,19.41,19.41,0,0,1-2,.66,5.54,5.54,0,0,1,1.9-1,13.75,13.75,0,0,1,5.14-.85,13.53,13.53,0,0,1,5.08,1.11A5.7,5.7,0,0,1,59.27,210.32Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.1,258.47c-.08,1.17-3.35,62.87-.4,65.59s22.36-2.55,22.62-2.43,14.82-24.72,12.2-30.29-21.2-32.53-21.2-32.53l-2.65-7.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.29,255.56c-.45.16-7.17,16-7.17,16S43.26,283.5,43.41,287.39s15.07,34.13,20,33.79,5.32-9.64,5.32-9.64L69.48,258Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.86,
    y: 248.45,
    width: 75.83,
    height: 14.23,
    transform: "translate(-9.9 4.29) rotate(-2.24)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.74,265.1a8.14,8.14,0,0,1-.49-2.05c-.23-1.28-.48-3.06-.68-5s-.29-3.77-.32-5.08a8.17,8.17,0,0,1,.09-2.11c.14,0,.36,3.2.75,7.14S67.89,265.08,67.74,265.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.22,263a49.51,49.51,0,0,1-1-7,48.69,48.69,0,0,1-.53-7.11,50.13,50.13,0,0,1,1,7.05A50.41,50.41,0,0,1,102.22,263Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.37,292.69a3.73,3.73,0,0,1-.53.17c-.35.1-.86.23-1.54.38a38,38,0,0,1-5.76.85,23,23,0,0,1-8.6-.95,16,16,0,0,1-8.51-6.18,37.44,37.44,0,0,1-4.55-9.57c-1.07-3.07-1.92-5.87-2.57-8.24s-1.11-4.3-1.4-5.64c-.15-.68-.25-1.2-.32-1.55a2.29,2.29,0,0,1-.07-.55,1.81,1.81,0,0,1,.18.52c.1.41.24.91.41,1.53.35,1.32.86,3.24,1.56,5.59s1.58,5.13,2.67,8.18a37.83,37.83,0,0,0,4.51,9.42,16.25,16.25,0,0,0,3.77,3.81,16.54,16.54,0,0,0,4.47,2.23,23.51,23.51,0,0,0,8.43,1,44,44,0,0,0,5.74-.68l1.56-.28A1.73,1.73,0,0,1,164.37,292.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.36,190.79c.62,1.49,8,16,8.4,22.84s-12.48,46.18-12.48,46.18l-11-5.62,6.51-39.75-6.42-13Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.32,258.81c.26,0,6.79-.71,9-4.62s11,5.62,11,5.62.24,4.92-.85,7.72-2.06,4.73-2.06,4.73-.8,5.79-1.44,7-3.83,4.46-4.69,4.06-1.73-1-.87-2,3-3.13,3-3.91a38.89,38.89,0,0,0-1-4.17s-3.79,10.9-4.7,11.8a5.87,5.87,0,0,1-3,1.06s-1.91,1.8-3.22,1.16-.14-3.52-.14-3.52,2.64-11.72,2.63-12.07-2.21.86-2.54,3.37.12,7.4-2,7.4-1.55-6.83-1.49-9.67,1.24-3.58,1.85-5.41S143.32,258.81,143.32,258.81Z",
    style: {
      fill: "#ae7461"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorker);
export default __webpack_public_path__ + "static/media/worker.c0e08ccb0e2c1833f2721a76f8f4c346.svg";
export { ForwardRef as ReactComponent };